  import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
  import { Link, useSearchParams } from "react-router-dom";
  import DateRangePicker from "react-bootstrap-daterangepicker";
  import { Modal, Button } from "react-bootstrap";
  import { useDispatch, useSelector } from "react-redux";
  import { all_routes } from "../../router/all_routes";
  import CollapseHeader from "../../../core/common/collapse-header";
  import {
    checkDuplicateContacts,
    Contact,
    fetchAllContacts,
    importNonDuplicateContacts,
    CompanyResponse,
    deleteCompany,
    deleteCompaniesBulk,
    updateCompany,
    updateLeadOwner,
    updateBulkLeadOwner,
    ImportSummary,
    exportContactsPdfCustomized,
    exportContactsExcelCustomized,
    Branch,
  } from "../../../api/contact";
  import axios from "axios";
  import { API_BASE_PATH } from "../../../environment";
  import {
    exportContactsPDF,
    exportContactsExcel,
    exportSelectedContactsPDF,
    exportSelectedContactsExcel,
  } from "../../../api/contact";
  import { toast } from "react-toastify";
  import { Avatar,Menu,Dropdown,Button as AntButton,Checkbox} from "antd";
  import { DownOutlined,FilterOutlined,FunnelPlotFilled,MinusOutlined,PlusOutlined,StarFilled,StarOutlined,UserDeleteOutlined,UserOutlined } from '@ant-design/icons';
  import type { ColumnsType } from "antd/es/table";
  import { LeadSource, fetchAllLeadSourcesActive } from "../../../api/leadsource";
  import { User } from "../../../api/usermanager";
  import { highlightMatch } from "../../../core/common/highlightmatch";
  import { fetchUsersByClientId } from "../../../api/todo";
  import { initialSettings } from "../../../core/common/selectoption/selectoption";
  import { AppDispatch, RootState } from "../../../core/data/redux/store";
  import {
    deleteContact,
    loadContacts,
  } from "../../../core/data/redux/contactSlice";
  import { fetchReduxReLeadsThunk } from "../../../core/data/redux/leadSlice";
  import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
  import {
    LeadGivenBy,
    fetchAllLeadGivenByActive,
  } from "../../../api/leadgivenby";
  import Table from "../../../core/common/dataTable/index";

  import {
    fetchAllProductTypesActive,
    ProductType,
  } from "../../../api/producttype";
  import {
    fetchAllCustomerPotentialsActive,
    CustomerPotential,
  } from "../../../api/customertype";
  import {
    Product,
    fetchAllProductsActive,
  } from "../../../api/product";
  import Select from "react-select";
  import ConvertToLeadModal from "./ConvertToLeadModal";
  import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";
  import ScrollToTop from "../../../core/common/ScrollToTop";
  import ContactDetailsModal from "../../../core/common/ContactDetailsModal";
  import CountUp from "react-countup";
  import { validateImportName } from "../../../api/mainValidation";
  import SequentialHighlight from "../../../core/common/SequentialHighlight";
  import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
  import ColumnManagement from "../../../core/common/ColumnManagement";
  import TextCopy2 from "../../../core/common/textcopy2";
  import LeadOwnerHoverCard from "../../../core/common/LeadOwnerHoverCard";


  const modalPositions: Record<
    string,
    { left: string; top: string; position: string; isCenteredRemoved: boolean }
  > = {};

  const restoreModalPosition = (modalElement: HTMLElement) => {
    const id = modalElement.id;
    const saved = modalPositions[id];
    if (saved) {
      const modalDialog = modalElement.classList.contains("modal-dialog")
        ? modalElement
        : (modalElement.querySelector(".modal-dialog") as HTMLElement);

      if (modalDialog) {
        modalDialog.style.left = saved.left;
        modalDialog.style.top = saved.top;
        modalDialog.style.position = saved.position;
        if (saved.isCenteredRemoved) {
          modalDialog.classList.remove("modal-dialog-centered");
        }
      }
    }
  };

  const setupDraggable = (modalElement: HTMLElement) => {
    if (modalElement.hasAttribute("data-draggable-setup")) {
      restoreModalPosition(modalElement);
      return;
    }
    modalElement.setAttribute("data-draggable-setup", "true");

    const modalDialog = modalElement.classList.contains("modal-dialog")
      ? modalElement
      : (modalElement.querySelector(".modal-dialog") as HTMLElement);
    const modalHeader = modalElement.querySelector(".modal-header") as HTMLElement;

    if (!modalDialog || !modalHeader) return;

    const id = modalElement.id; // Use element ID as key

    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;

    const onMouseDown = (e: MouseEvent) => {
      if ((e.target as HTMLElement).closest("button,input,select,.btn-close"))
        return;

      isDragging = true;
      const rect = modalDialog.getBoundingClientRect();
      offsetX = e.clientX - rect.left;
      offsetY = e.clientY - rect.top;

      modalDialog.classList.remove("modal-dialog-centered");
      modalDialog.style.position = "fixed";
      
      // Save state immediately
      modalPositions[id] = {
        left: modalDialog.style.left,
        top: modalDialog.style.top,
        position: "fixed",
        isCenteredRemoved: true,
      };
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;

      const left = `${e.clientX - offsetX}px`;
      const top = `${e.clientY - offsetY}px`;

      modalDialog.style.left = left;
      modalDialog.style.top = top;
      
      // Update saved state
      if (modalPositions[id]) {
        modalPositions[id].left = left;
        modalPositions[id].top = top;
      }
    };

    const onMouseUp = () => (isDragging = false);

    modalHeader.style.cursor = "move";
    modalHeader.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const ContactList = () => {
    const route = all_routes;
    const dispatch = useDispatch<AppDispatch>();
    const { contacts: contactData, status } = useSelector(
      (state: RootState) => state.contacts
    );

    const [filters, setFilters] = useState({
      name: "",
      phone: "",
      email: "",
      designation: "",
      company: "",
      leadOwner: "",
      leadSource: "",
      leadGivenBy: "",
    });
    const [assignmentFilter, setAssignmentFilter] = useState("all");
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
    const [selectedContactForAssign, setSelectedContactForAssign] =
      useState<Contact | null>(null);
    const [users, setUsers] = useState<User[]>([]);
    const [selectedUserId, setSelectedUserId] = useState<string>("");
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [deleting, setDeleting] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
      const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);
    const [selectedContactForView, setSelectedContactForView] = useState<Contact | null>(null);
    const [searchParams] = useSearchParams();
    const [selectedDateRange, setSelectedDateRange] = useState<
      [Date, Date] | null
    >(null);
    const [activeRangeLabel, setActiveRangeLabel] = useState("Last 30 Days");
    const [addressMode, setAddressMode] = useState<"single" | "multiple">(
      "single"
    );
    const [addresses, setAddresses] = useState([
      {
        branch_name: "",
        contact_address: "",
        contact_city: "",
        contact_state: "",
        contact_zipcode: "",
        contact_country: "",
        gst_number: "",
      },
    ]);
    const [importFile, setImportFile] = useState<File | null>(null);
    const [importReferenceName, setImportReferenceName] = useState("");
    const [showImportModal, setShowImportModal] = useState(false);
    const [showImportSuccessModal, setShowImportSuccessModal] = useState(false);
    const [duplicates, setDuplicates] = useState<any[]>([]);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [importSummary, setImportSummary] = useState<ImportSummary | null>(
      null
    );
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedContacts, setSelectedContacts] = useState<string[]>([]);
    const [editContact, setEditContact] = useState<Partial<Contact> | null>(null);
    const [contactToDelete, setContactToDelete] = useState<string | null>(null);
    const [sortOption, setSortOption] = useState("recently_added");
    const [contacts, setContacts] = useState<Contact[]>([]);
    const [orderedData, setOrderedData] = useState<Contact[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [openModal2, setOpenModal2] = useState(false);
    const [allContacts, setAllContacts] = useState<Contact[]>([]);
    const [leadSources, setLeadSources] = useState<LeadSource[]>([]);
    const [leadGivenBys, setLeadGivenBys] = useState<LeadGivenBy[]>([]);
    const [filterNames, setFilterNames] = useState<string[]>([]);
    const [filterCompanies, setFilterCompanies] = useState<string[]>([]);
    const [filterDesignations, setFilterDesignations] = useState<string[]>([]);
    const [filterOwners, setFilterOwners] = useState<string[]>([]);
    const [filterLeadSources, setFilterLeadSources] = useState<string[]>([]);
    const [filterLeadGivenBy, setFilterLeadGivenBy] = useState<string[]>([]);
    const [filterNamesSearch, setFilterNamesSearch] = useState("");
    const [filterCompaniesSearch, setFilterCompaniesSearch] = useState("");
    const [filterDesignationsSearch, setFilterDesignationsSearch] = useState("");
    const [filterOwnersSearch, setFilterOwnersSearch] = useState("");
    const [filterLeadSourcesSearch, setFilterLeadSourcesSearch] = useState("");
    const [filterLeadGivenBySearch, setFilterLeadGivenBySearch] = useState("");
    const [openAccordion, setOpenAccordion] = useState<string | null>(null);
    const [filterPhones, setFilterPhones] = useState<string[]>([]);
    const [filterEmails, setFilterEmails] = useState<string[]>([]);
    const [filterPhonesSearch, setFilterPhonesSearch] = useState("");
    const [filterEmailsSearch, setFilterEmailsSearch] = useState("");
    const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
    const [selectedOwners, setSelectedOwners] = useState<string[]>([]);
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
    const [alphaFilter, setAlphaFilter] = useState<string>("All");
    const [alphaFilterleadsource, setAlphaFilterleadsource] = useState<string>("All");
    const [alphaFilterleadowner, setAlphaFilterleadowner] = useState<string>("All");
    const [alphaFilterleadgiven, setAlphaFilterleadgiven] = useState<string>("All");
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [showConvertToLeadModal, setShowConvertToLeadModal] = useState(false);
    const [productTypes, setProductTypes] = useState<ProductType[]>([]);
    const [customerPotentials, setCustomerPotentials] = useState<CustomerPotential[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const userRole = useSelector((state: RootState) => state.auth.role);
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
    const [assignOnCreate, setAssignOnCreate] = useState(false);
  const [selectedUserForCreate, setSelectedUserForCreate] = useState<string>("");
    const [importNameError, setImportNameError] = useState<string | undefined>();
      const [isSubmitting, setIsSubmitting] = useState(false);

        const [favorites, setFavorites] = useState<string[]>(() => {
      const saved = localStorage.getItem("contactFavorites");
      return saved ? JSON.parse(saved) : [];
    });
    const [showOnlyFavorites, setShowOnlyFavorites] = useState(false);

    const favoriteCount = useMemo(() => favorites.length, [favorites]);

    const toggleFavorite = useCallback((contactId: string) => {
      setFavorites((prev) => {
        const isFav = prev.includes(contactId);
        const updated = isFav
          ? prev.filter((id) => id !== contactId)
          : [...prev, contactId];
        localStorage.setItem("contactFavorites", JSON.stringify(updated));
        return updated;
      });
    }, []);
    const defaultVisibleColumns = {
      name: true,
      phone: true,
      email: true,
      location: true,
      actions: true,
      description: true,
      address: false,
      country: false,
      company: false,
      designation: true,
      website: true,
      created_at: true,
      username: true,
      leadsource_name: true,
      leadgivenby_name: true,
    };

    const [visibleColumns, setVisibleColumns] = useState(() => {
      const saved = localStorage.getItem("visibleColumns");
      return saved ? JSON.parse(saved) : defaultVisibleColumns;
    });
    const defaultColumnOrder = [
      "name",
      "phone",
      "email",
      "designation",
      "company",
      "username",
      "leadsource_name",
      "leadgivenby_name",
      "website",
      "description",
      "created_at",
    ];
    const columnLabels: Record<string, string> = {
      name: "Contact Name",
      phone: "Phone",
      email: "Email",
      designation: "Designation",
      company: "Company",
      username: "Lead Owner",
      website: "Website",
      leadsource_name: "Lead Source",
      leadgivenby_name: "Lead Given By",
      description: "Remarks",
      created_at: "Created At",
    };


    const [newContact, setNewContact] = useState({
      contact_name: "",
      contact_mail: "",
      branch_name: "",
      contact_phone: "",
      contact_description: "",
      contact_address: "",
      contact_city: "",
      contact_state: "",
      contact_zipcode: "",
      contact_country: "",
      contact_Company_name: "",
      contact_desigination: "",
      website_url: "",
      lead_from: "",
      gst_number: "",
      leadgivenby_id: "",
    });

    const fetchUsers = useCallback(async (clientId: string) => {
      setLoadingUsers(true);
      try {
        if (!clientId) return;
        const fetchedUsers = await fetchUsersByClientId(clientId);
        setUsers(fetchedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Failed to load users for assignment.");
      } finally {
        setLoadingUsers(false);
      }
    }, []);

    const handleOpenAssignModal = useCallback(
      (contact: Contact) => {
        setSelectedContactForAssign(contact);
        setSelectedUserId("");
        if (contact.client_id) {
          fetchUsers(contact.client_id);
        } else {
          toast.error("No client ID found for this contact.");
        }
        setShowAssignModal(true);
      },
      [fetchUsers]
    );

    const handleOpenBulkAssignModal = useCallback(() => {
      if (selectedContacts.length === 0) {
        toast.error("Please select at least one contact to assign.");
        return;
      }
      const firstContact = contacts.find((c) =>
        selectedContacts.includes(c.contact_id)
      );
      if (firstContact?.client_id) {
        fetchUsers(firstContact.client_id);
      } else {
        toast.error("No client ID found for selected contacts.");
      }
      setSelectedUserId("");
      setShowBulkAssignModal(true);
    }, [selectedContacts, contacts, fetchUsers]);

    const handleAssignUser = useCallback(async () => {
      if (!selectedContactForAssign || !selectedUserId) {
        toast.error("Please select a user to assign.");
        return;
      }
      try {
        await updateLeadOwner(
          selectedContactForAssign.contact_id,
          selectedUserId
        );
        setShowAssignModal(false);
        setSelectedContactForAssign(null);
        setSelectedUserId("");
        dispatch(loadContacts());
        toast.success("Lead owner assigned successfully!");
      } catch (error) {
        console.error("Error assigning user:", error);
        toast.error("Failed to assign user.");
      }
    }, [selectedContactForAssign, selectedUserId, dispatch]);

    const handleBulkAssignUser = useCallback(async () => {
      if (!selectedUserId) {
        toast.error("Please select a user to assign.");
        return;
      }
      try {
        await updateBulkLeadOwner(selectedContacts, selectedUserId);
        setShowBulkAssignModal(false);
        setSelectedUserId("");
        setSelectedContacts([]);
        dispatch(loadContacts());
        toast.success("Lead owner assigned successfully to selected contacts!");
      } catch (error) {
        console.error("Error assigning users in bulk:", error);
        toast.error("Failed to assign users in bulk.");
      }
    }, [selectedUserId, selectedContacts, dispatch]);

    const handleBulkDelete = async () => {
    if (selectedContacts.length === 0) return;

    try {
      await deleteCompaniesBulk(selectedContacts);
      toast.success("Selected contacts deleted successfully!");

      await  dispatch(loadContacts());

      setSelectedContacts([]);
    } catch (error) {
      console.error("Error during bulk delete:", error);
      toast.error("Failed to delete selected contacts.");
    }
  };


    const resetFilters = useCallback(() => {
      setSearchQuery("");
      setSelectedDateRange(null);
      setFilters({
        name: "",
        phone: "",
        email: "",
        designation: "",
        company: "",
        leadOwner: "",
        leadSource: "",
        leadGivenBy: "",
      });
      setShowOnlyFavorites(false);
    }, []);

    useEffect(() => {
      const loadLeadSources = async () => {
        const sources = await fetchAllLeadSourcesActive();
        setLeadSources(sources);
      };
      loadLeadSources();
    }, []);

    useEffect(() => {
      const loadLeadGivenBy = async () => {
        const data = await fetchAllLeadGivenByActive();
        setLeadGivenBys(data);
      };
      loadLeadGivenBy();
    }, []);

    useEffect(() => {
      const loadDropdowns = async () => {
        try {
          const [pTypes, cPotentials, prods] = await Promise.all([
            fetchAllProductTypesActive(),
            fetchAllCustomerPotentialsActive(),
            fetchAllProductsActive(),
          ]);
          setProductTypes(pTypes);
          setCustomerPotentials(cPotentials);
          setProducts(prods);
        } catch (error) {
          console.error("Error loading dropdowns:", error);
        }
      };
      loadDropdowns();
    }, []);

    const handleOpenConvertModal = useCallback(() => {
      if (selectedContacts.length === 0) {
        toast.error("Please select at least one contact to convert.");
        return;
      }
      setShowConvertToLeadModal(true);
    }, [selectedContacts]);
      const handleImportExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setImportFile(file);
      }
    };
    useEffect(() => {
      if (status === "idle") {
        dispatch(loadContacts());
      } else if (status === "succeeded") {
        const transformed = contactData.map((item: CompanyResponse) => {
          const addressMode: "single" | "multiple" =
            item.branches && item.branches.length > 1 ? "multiple" : "single";
          return {
            contact_id: item.company.contact_id,
            contact_name: item.company.contact_person_name,
            contact_mail: item.company.company_mail,
            contact_phone: item.company.company_phone,
            contact_description: item.company.contact_remark,
            contact_Company_name: item.company.company_name,
            contact_desigination: item.company.contact_person_desigination,
            lead_from: item.company.leadsource_id,
            leadsource_name: item.company?.leadsource_name,
            website_url: item.company.website_url,
            created_at: item.company.created_at,
            client_id: item.company.client_id,
            branches: item.branches,
            address_mode: addressMode,
            username: item.company.username,
            leadgivenby_id: item.company.leadgivenby_id,
            leadgivenby_name: item.company?.LeadGivenBy_name,
          };
        });
        setContacts(transformed);
        setAllContacts(transformed);
        setOrderedData(transformed);
        setLoading(false);
      }
      if (status === "loading") {
        setLoading(true);
      }
    }, [status, contactData, dispatch]);

    useEffect(() => {
      const nameParam = searchParams.get("name");
      const emailParam = searchParams.get("email");
      const phoneParam = searchParams.get("phone");
      const sortParam = searchParams.get("sort");
      const unassignedParam = searchParams.get("unassigned");

      if (sortParam) {
        setSortOption(decodeURIComponent(sortParam));
      }
      if (nameParam) {
        setFilters((prev) => ({ ...prev, name: decodeURIComponent(nameParam) }));
      }
      if (emailParam) {
        setFilters((prev) => ({
          ...prev,
          email: decodeURIComponent(emailParam),
        }));
      }
      if (phoneParam) {
        setFilters((prev) => ({
          ...prev,
          phone: decodeURIComponent(phoneParam),
        }));
      }
      if (unassignedParam === "true") {
        setAssignmentFilter("unassigned");
      }
    }, [searchParams]);

    const filteredAndSortedContacts = useMemo(() => {
      return allContacts
        .filter((contact) => {
          const query = debouncedSearchQuery.toLowerCase();
          const name = contact.contact_name?.toLowerCase() || "";
          const mail = contact.contact_mail?.toLowerCase() || "";
          const phone = contact.contact_phone?.toLowerCase() || "";
          const company = contact.contact_Company_name?.toLowerCase() || "";
          const designation = contact.contact_desigination?.toLowerCase() || "";
          const createdAt = contact.created_at
            ? new Date(contact.created_at)
            : null;
          const country =
            contact.branches?.[0]?.branch_country?.toLowerCase() || "";
          const leadOwner = contact.username?.trim().toLowerCase() || "";
          const leadSource = contact.leadsource_name?.trim().toLowerCase() || "";
          const leadGivenBy = (contact.leadgivenby_name || "")
            .trim()
            .toLowerCase() || "";
            const website = contact.website_url?.toLowerCase() || "";
            const remark = contact.contact_description?.trim().toLowerCase() || "";
          
          const metapage = contact.meta_page?.toLowerCase() || "";
          

          const searchMatch =
            name.includes(query) ||
            mail.includes(query) ||
            phone.includes(query) ||
            company.includes(query) ||
            designation.includes(query)  ||
            website.includes(query) ||
            leadOwner.includes(query) ||
            leadSource.includes(query) ||
            remark.includes(query) ||
            country.includes(query) ||
            metapage.includes(query) ||
            phone.includes(query) ||
            leadGivenBy.includes(query);

          const alphaMatch =
    alphaFilter === "All" ||
    (contact.contact_Company_name || "").toLowerCase().startsWith(alphaFilter.toLowerCase());

      const alphaMatches =
    alphaFilterleadsource === "All" ||
    (contact.leadsource_name || "").toLowerCase().startsWith(alphaFilterleadsource.toLowerCase());
            const alphaMat =
    alphaFilterleadowner === "All" ||
    (contact.username || "").toLowerCase().startsWith(alphaFilterleadowner.toLowerCase());
            const alphaMatleadgiven =
    alphaFilterleadgiven === "All" ||
    (contact.leadgivenby_name || "").toLowerCase().startsWith(alphaFilterleadgiven.toLowerCase());

          const nameMatch =
            filterNames.length === 0 ||
            filterNames.some((f) => name.includes(f.toLowerCase()));
          const companyMatch =
            filterCompanies.length === 0 ||
            filterCompanies.some((f) => company.includes(f.toLowerCase()));
          const designationMatch =
            filterDesignations.length === 0 ||
            filterDesignations.some((f) => designation.includes(f.toLowerCase()));
          const ownerMatch =
            filterOwners.length === 0 ||
            filterOwners.some((f) => leadOwner.includes(f.toLowerCase()));
          const leadSourceMatch =
            filterLeadSources.length === 0 ||
            filterLeadSources.some((f) => leadSource.includes(f.toLowerCase()));
          const leadGivenByMatch =
            filterLeadGivenBy.length === 0 ||
            filterLeadGivenBy.some((f) => leadGivenBy.includes(f.toLowerCase()));
          const phoneMatch =
            filterPhones.length === 0 ||
            filterPhones.some((f) => phone.includes(f.toLowerCase()));
          const emailMatch =
            filterEmails.length === 0 ||
            filterEmails.some((f) => mail.includes(f.toLowerCase()));
          const countryMatch =
            selectedCountries.length === 0 || selectedCountries.includes(country);
          const statusMatch =
            selectedStatuses.length === 0 ||
            selectedStatuses.includes(contact.status || "");
          const dateMatch =
            !selectedDateRange ||
            (createdAt &&
              createdAt >= selectedDateRange[0] &&
              createdAt <= selectedDateRange[1]);
          const leadOwnerAssignedMatch =
            assignmentFilter === "all"
              ? true
              : assignmentFilter === "unassigned"
              ? leadOwner === ""
              : leadOwner !== "";
          const favoriteMatch = showOnlyFavorites ? favorites.includes(contact.contact_id) : true;

          return (
            searchMatch &&
            nameMatch &&
            phoneMatch &&
            emailMatch &&
            designationMatch &&
            companyMatch &&
            dateMatch &&
            countryMatch &&
            statusMatch &&
            leadOwnerAssignedMatch &&
            leadSourceMatch &&
            leadGivenByMatch &&
            alphaMatch &&
            alphaMatches &&
            alphaMat &&
            favoriteMatch &&
            alphaMatleadgiven &&
            ownerMatch
          );
        })
        .sort((a, b) => {
          if (sortOption === "ascending")
            return (
              a.contact_Company_name?.localeCompare(
                b.contact_Company_name || ""
              ) || 0
            );
          if (sortOption === "descending")
            return (
              b.contact_Company_name?.localeCompare(
                a.contact_Company_name || ""
              ) || 0
            );
          if (sortOption === "recently_viewed")
            return (
              new Date(b.last_viewed || "").getTime() -
              new Date(a.last_viewed || "").getTime()
            );
          if (sortOption === "recently_added")
            return (
              new Date(b.created_at || "").getTime() -
              new Date(a.created_at || "").getTime()
            );
          return 0;
        });
    }, [
      allContacts,
      searchQuery,
      debouncedSearchQuery,
      filters,
      filterNames, // New deps
      filterCompanies,
      filterDesignations,
      filterOwners,
      filterLeadSources,
      filterLeadGivenBy,
      filterPhones, // Existing
      filterEmails,
      assignmentFilter,
      selectedDateRange,
      selectedStatuses,
      selectedCountries,
      sortOption,
      alphaFilter,
        showOnlyFavorites,
      favorites,
      alphaFilterleadowner,
      alphaFilterleadsource,
      alphaFilterleadgiven
    ]);

      const assignmentCounts = useMemo(() => {
      const total = contacts.length;
      const assigned = contacts.filter(
        (c) => (c.username?.trim() || "") !== ""
      ).length;
      const unassigned = total - assigned;

      return {
        all: total,
        assigned,
        unassigned,
      };
    }, [contacts]);

      useEffect(() => {
      const makeModalDraggable = (modalId: string) => {
        const modalElement = document.getElementById(modalId);
        if (!modalElement) return;

        const modalDialog = modalElement.querySelector(
          ".modal-dialog"
        ) as HTMLElement;
        const modalHeader = modalElement.querySelector(
          ".modal-header"
        ) as HTMLElement;

        if (!modalDialog || !modalHeader) return;

        let isDragging = false;
        let currentX = 0;
        let currentY = 0;
        let initialX = 0;
        let initialY = 0;
        let startX = 0;
        let startY = 0;

        // Reset position when modal is shown
        const resetPosition = () => {
          // Reset all position variables
          currentX = 0;
          currentY = 0;
          initialX = 0;
          initialY = 0;
          startX = 0;
          startY = 0;
          isDragging = false;

          // Remove only the inline styles that were added during dragging
          modalDialog.style.position = "";
          modalDialog.style.top = "";
          modalDialog.style.left = "";
          modalDialog.style.transform = "";
          modalDialog.style.margin = "";
          modalDialog.style.transition = "";
          modalDialog.style.width = "";
          modalDialog.style.maxWidth = "";

          // Restore centered class if it was removed
          if (!modalDialog.classList.contains("modal-dialog-centered")) {
            modalDialog.classList.add("modal-dialog-centered");
          }
        };

        // Listen for modal show event - reset when modal is about to show
        const handleShow = () => {
          // Reset immediately when modal starts showing
          resetPosition();
        };

        // Listen for modal shown event - ensure reset after modal is fully displayed
        const handleShown = () => {
          // Double-check reset after modal is fully shown
          resetPosition();
        };

        // Listen for modal hidden event - reset when modal is fully hidden
        const handleHidden = () => {
          resetPosition();
        };

        modalElement.addEventListener("show.bs.modal", handleShow);
        modalElement.addEventListener("shown.bs.modal", handleShown);
        modalElement.addEventListener("hidden.bs.modal", handleHidden);

        const dragStart = (e: MouseEvent) => {
          // Only allow dragging from header, not from close button or other interactive elements
          const target = e.target as HTMLElement;
          if (
            target.closest(".btn-close") ||
            target.closest("button") ||
            target.closest("input") ||
            target.closest("select")
          ) {
            return;
          }

          if (
            e.target === modalHeader ||
            modalHeader.contains(e.target as Node)
          ) {
            isDragging = true;
            modalHeader.style.cursor = "move";

            // Get current position and size of modal dialog
            const rect = modalDialog.getBoundingClientRect();
            startX = rect.left;
            startY = rect.top;

            // Get computed styles to preserve the modal's size
            const computedStyle = getComputedStyle(modalDialog);
            const currentWidth = computedStyle.width;
            const currentMaxWidth = computedStyle.maxWidth;
            const currentMinWidth = computedStyle.minWidth;

            // Remove centered class to allow free movement
            modalDialog.classList.remove("modal-dialog-centered");

            // Set initial position based on current position
            modalDialog.style.position = "fixed";
            modalDialog.style.top = `${startY}px`;
            modalDialog.style.left = `${startX}px`;
            modalDialog.style.margin = "0";
            modalDialog.style.transform = "none";
            modalDialog.style.transition = "none";

            // Preserve the modal's width and max-width to prevent size change
            if (
              currentWidth &&
              currentWidth !== "auto" &&
              currentWidth !== "0px"
            ) {
              modalDialog.style.width = currentWidth;
            }
            if (
              currentMaxWidth &&
              currentMaxWidth !== "none" &&
              currentMaxWidth !== "0px"
            ) {
              modalDialog.style.maxWidth = currentMaxWidth;
            }
            if (
              currentMinWidth &&
              currentMinWidth !== "0px" &&
              currentMinWidth !== "auto"
            ) {
              modalDialog.style.minWidth = currentMinWidth;
            }

            initialX = e.clientX - startX;
            initialY = e.clientY - startY;
          }
        };

        const drag = (e: MouseEvent) => {
          if (!isDragging) return;

          e.preventDefault();

          // Calculate new position
          const newX = e.clientX - initialX;
          const newY = e.clientY - initialY;

          // Get modal dialog dimensions
          const rect = modalDialog.getBoundingClientRect();
          const maxX = window.innerWidth - rect.width;
          const maxY = window.innerHeight - rect.height;

          // Constrain to viewport
          const constrainedX = Math.max(0, Math.min(newX, maxX));
          const constrainedY = Math.max(0, Math.min(newY, maxY));

          // Update position
          modalDialog.style.left = `${constrainedX}px`;
          modalDialog.style.top = `${constrainedY}px`;

          // Store current position for next drag
          currentX = constrainedX;
          currentY = constrainedY;
        };

        const dragEnd = () => {
          if (isDragging) {
            isDragging = false;
            modalHeader.style.cursor = "move";
            modalDialog.style.transition = "";
            // Keep the fixed positioning during drag, but allow reset on next open
          }
        };

        // Add cursor style to header
        modalHeader.style.cursor = "move";
        modalHeader.style.userSelect = "none";

        // Event listeners
        modalHeader.addEventListener("mousedown", dragStart);
        document.addEventListener("mousemove", drag);
        document.addEventListener("mouseup", dragEnd);

        // Cleanup function
        return () => {
          modalElement.removeEventListener("show.bs.modal", handleShow);
          modalElement.removeEventListener("shown.bs.modal", handleShown);
          modalElement.removeEventListener("hidden.bs.modal", handleHidden);
          modalHeader.removeEventListener("mousedown", dragStart);
          document.removeEventListener("mousemove", drag);
          document.removeEventListener("mouseup", dragEnd);
        };
      };

      // Make delete modal draggable
      const cleanup = makeModalDraggable("delete_contact");
      const cleanup1 = makeModalDraggable("bulk_delete_contacts");
      const cleanup2 = makeModalDraggable("bulk_assign_modal");
      const cleanup3 = makeModalDraggable("assign_user_modal");
      const cleanup4 = makeModalDraggable("import_contacts_modal");
      const cleanup5 = makeModalDraggable("duplicate_contacts_modal");
      const cleanup6 = makeModalDraggable("import_success_modal");
      const cleanup7 = makeModalDraggable("tag_input_modal");
      return () => {
        cleanup?.();
        cleanup1?.();
        cleanup2?.();
        cleanup3?.();
        cleanup4?.();
        cleanup5?.();
        cleanup6?.();
        cleanup7?.();
      };
    }, []);

    // Make React Bootstrap modals draggable (Assign To and Bulk Delete)
    useEffect(() => {
      const setupModalDraggable = (modalElement: HTMLElement) => {
        if (modalElement.hasAttribute("data-draggable-setup")) return;
        modalElement.setAttribute("data-draggable-setup", "true");

        const modalDialog = modalElement.querySelector(
          ".modal-dialog"
        ) as HTMLElement;
        const modalHeader = modalElement.querySelector(
          ".modal-header"
        ) as HTMLElement;

        if (!modalDialog || !modalHeader) return;

        let isDragging = false;
        let initialX = 0;
        let initialY = 0;
        let startX = 0;
        let startY = 0;

        const resetPosition = () => {
          isDragging = false;
          modalDialog.style.position = "";
          modalDialog.style.top = "";
          modalDialog.style.left = "";
          modalDialog.style.transform = "";
          modalDialog.style.margin = "";
          modalDialog.style.transition = "";
          modalDialog.style.width = "";
          modalDialog.style.maxWidth = "";

          if (!modalDialog.classList.contains("modal-dialog-centered")) {
            modalDialog.classList.add("modal-dialog-centered");
          }
        };

        const dragStart = (e: MouseEvent) => {
          const target = e.target as HTMLElement;
          if (
            target.closest(".btn-close") ||
            target.closest("button") ||
            target.closest("input") ||
            target.closest("select")
          ) {
            return;
          }

          if (
            e.target === modalHeader ||
            modalHeader.contains(e.target as Node)
          ) {
            isDragging = true;
            modalHeader.style.cursor = "move";

            const rect = modalDialog.getBoundingClientRect();
            startX = rect.left;
            startY = rect.top;

            const computedStyle = getComputedStyle(modalDialog);
            const currentWidth = computedStyle.width;
            const currentMaxWidth = computedStyle.maxWidth;
            const currentMinWidth = computedStyle.minWidth;

            modalDialog.classList.remove("modal-dialog-centered");

            modalDialog.style.position = "fixed";
            modalDialog.style.top = `${startY}px`;
            modalDialog.style.left = `${startX}px`;
            modalDialog.style.margin = "0";
            modalDialog.style.transform = "none";
            modalDialog.style.transition = "none";

            if (
              currentWidth &&
              currentWidth !== "auto" &&
              currentWidth !== "0px"
            ) {
              modalDialog.style.width = currentWidth;
            }
            if (
              currentMaxWidth &&
              currentMaxWidth !== "none" &&
              currentMaxWidth !== "0px"
            ) {
              modalDialog.style.maxWidth = currentMaxWidth;
            }
            if (
              currentMinWidth &&
              currentMinWidth !== "0px" &&
              currentMinWidth !== "auto"
            ) {
              modalDialog.style.minWidth = currentMinWidth;
            }

            initialX = e.clientX - startX;
            initialY = e.clientY - startY;
          }
        };

        const drag = (e: MouseEvent) => {
          if (!isDragging) return;
          e.preventDefault();

          const newX = e.clientX - initialX;
          const newY = e.clientY - initialY;

          const rect = modalDialog.getBoundingClientRect();
          const maxX = window.innerWidth - rect.width;
          const maxY = window.innerHeight - rect.height;

          const constrainedX = Math.max(0, Math.min(newX, maxX));
          const constrainedY = Math.max(0, Math.min(newY, maxY));

          modalDialog.style.left = `${constrainedX}px`;
          modalDialog.style.top = `${constrainedY}px`;
        };

        const dragEnd = () => {
          if (isDragging) {
            isDragging = false;
            modalHeader.style.cursor = "move";
            modalDialog.style.transition = "";
          }
        };

        modalHeader.style.cursor = "move";
        modalHeader.style.userSelect = "none";

        modalHeader.addEventListener("mousedown", dragStart);
        document.addEventListener("mousemove", drag);
        document.addEventListener("mouseup", dragEnd);

        // Reset on modal hide
        const handleHidden = () => {
          resetPosition();
          modalElement.removeAttribute("data-draggable-setup");
        };

        modalElement.addEventListener("hidden.bs.modal", handleHidden);
      };

      // Watch for modals appearing
      const checkAndSetup = () => {
        const modals = document.querySelectorAll(".modal.show");
        modals.forEach((modal) => {
          const modalEl = modal as HTMLElement;
          const title = modalEl.querySelector(".modal-title")?.textContent || "";
          const h4 = modalEl.querySelector("h4")?.textContent || "";

          if (
            (title.includes("Assign User") ||
              h4.includes("Confirm Bulk Delete")) &&
            !modalEl.hasAttribute("data-draggable-setup")
          ) {
            setTimeout(() => setupModalDraggable(modalEl), 50);
          }
        });
      };

      const interval = setInterval(checkAndSetup, 100);

      return () => {
        clearInterval(interval);
      };
    }, [showAssignModal, showBulkAssignModal, showBulkDeleteModal]);

  useEffect(() => {
      const styleId = "animated-badge-keyframes";
      if (!document.getElementById(styleId)) {
        const styleSheet = document.createElement("style");
        styleSheet.id = styleId;
        styleSheet.innerText = `
          @keyframes shine {
            0% {
              transform: skewX(-20deg) translateX(-150%);
            }
            50% {
              transform: skewX(-20deg) translateX(150%);
            }
            100% {
              transform: skewX(-20deg) translateX(150%);
            }
          }
        `;
        document.head.appendChild(styleSheet);
      }
    }, []);
    const leadSourceCounts = useMemo((): Record<string, number> & {
      all: number;
    } => {
      const counts: Record<string, number> = {};
      let total = 0;

      contacts.forEach((contact) => {
        const source = contact.leadsource_name?.trim() || "Unknown";
        counts[source] = (counts[source] || 0) + 1;
        total++;
      });

      return {
        ...counts,
        all: total,
      };
    }, [contacts]);

    const handleInputChange = useCallback(
      (
        e: React.ChangeEvent<
          HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
      ) => {
        const { name, value } = e.target;
        setNewContact((prev) => ({ ...prev, [name]: value }));
      },
      []
    );

    const phoneRegex = /^(\d{10}|\d{12}|\+91\d{10})$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const handleSubmit = useCallback(async () => {
      const {
        contact_Company_name,
        contact_name,
        contact_phone,
        contact_mail,
        contact_desigination,
        lead_from,
        leadgivenby_id,
      } = newContact;

      if (!contact_Company_name) return toast.error("Company name is required.");
      if (!contact_name) return toast.error("Contact person name is required.");
      if (!contact_phone || !phoneRegex.test(contact_phone))
        return toast.error(
          "Phone must be 10, 12 digits, or start with +91 followed by 10 digits."
        );
      if (!lead_from) return toast.error("Lead source is required.");
      if (!leadgivenby_id) return toast.error("Lead given by is required.");

      try {
        const token = localStorage.getItem("authToken") || "";
        const form = new URLSearchParams();

        form.append("company_name", contact_Company_name || "");
        form.append("website_url", newContact.website_url || "");
        form.append("company_mail", contact_mail || "");
        form.append("company_phone", contact_phone || "");
        form.append("contact_remark", newContact.contact_description || "");
        form.append("contact_person_name", contact_name || "");
        form.append("contact_person_desigination", contact_desigination || "");
        form.append("leadsource_id", lead_from || "");
        form.append("leadgivenby_id", newContact.leadgivenby_id || "");
        const addressList = addressMode === "single" ? [newContact] : addresses;

        const isNoCityProvided = addressList.every(
          (addr) => !addr.contact_city?.trim()
        );

        if (isNoCityProvided) {
          return toast.error("At least one branch address must include a city.");
        }

        if (addressMode === "single") {
          form.append("branch_name_1", "Main Branch");
          form.append("branch_address_1", newContact.contact_address || "");
          form.append("branch_city_1", newContact.contact_city || "");
          form.append("branch_state_1", newContact.contact_state || "");
          form.append("branch_zipcode_1", newContact.contact_zipcode || "");
          form.append("branch_country_1", newContact.contact_country || "");
          form.append("gst_number_1", newContact.gst_number || "");
        } else {
          addresses.forEach((addr, index) => {
            const i = index + 1;
            form.append(`branch_name_${i}`, `Branch ${i}`);
            form.append(`branch_address_${i}`, addr.contact_address || "");
            form.append(`branch_city_${i}`, addr.contact_city || "");
            form.append(`branch_state_${i}`, addr.contact_state || "");
            form.append(`branch_zipcode_${i}`, addr.contact_zipcode || "");
            form.append(`branch_country_${i}`, addr.contact_country || "");
            form.append(`gst_number_${i}`, addr.gst_number || "");
          });
        }

  const createResponse = await axios.post(`${API_BASE_PATH}/company/`, form, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: token,
    },
  });
  // After contact is created successfully (after you get response with contact_id)
  const createdContactId =
  createResponse?.data?.company_id ||
    createResponse?.data?.contact_id ||
    createResponse?.data?.company?.contact_id;
console.log("assignOnCreate:", assignOnCreate);
console.log("selectedUserForCreate:", selectedUserForCreate);
console.log("createdContactId:", createdContactId);

if (assignOnCreate && selectedUserForCreate && createdContactId) {
  try {
    console.log("Attempting to assign user...");
    await updateLeadOwner(createdContactId, selectedUserForCreate);
    toast.success("Contact created and lead owner assigned successfully!");
  } catch (error) {
    console.error("Assignment error:", error);
    toast.warning("Contact created but assignment failed");
  }
} else {
  console.log("Skipping assignment - one of the conditions is false");
}

  // Reset the assignment states
  setAssignOnCreate(false);
  setSelectedUserForCreate("");
  dispatch(loadContacts());
  toast.success("Company created successfully!");
 

        setNewContact({
          contact_name: "",
          branch_name: "",
          contact_mail: "",
          contact_phone: "",
          contact_description: "",
          contact_address: "",
          contact_city: "",
          contact_state: "",
          contact_zipcode: "",
          contact_country: "",
          contact_Company_name: "",
          contact_desigination: "",
          website_url: "",
          lead_from: "",
          gst_number: "",
          leadgivenby_id: "",
        });

        setAddresses([
          {
            branch_name: "",
            contact_address: "",
            contact_city: "",
            contact_state: "",
            contact_zipcode: "",
            contact_country: "",
            gst_number: "",
          },
        ]);

        const closeBtn = document.querySelector('#offcanvas_add [data-bs-dismiss="offcanvas"]');
        if (closeBtn) {
          (closeBtn as HTMLElement).click();
        }

      } catch (error) {
        console.error(error);
        toast.error("Failed to create company");
      }
    }, [newContact, addressMode, addresses, dispatch, assignOnCreate, selectedUserForCreate]);
    const handleEditContact = useCallback((contact: Contact) => {
      setEditContact(contact);
      setShowEditModal(true);
    }, []);

    const handleCloseEditModal = useCallback(() => {
      setShowEditModal(false);
      setEditContact(null);
    }, []);

    const handleUpdateContact = useCallback(async () => {
      if (!editContact?.contact_id) {
        toast.error("Missing contact ID");
        return;
      }
      if (!editContact.contact_Company_name)
        return toast.error("Company name is required.");
      if (!editContact.contact_name)
        return toast.error("Contact person name is required.");
      // if (!editContact.contact_desigination)
      //   return toast.error("Designation is required.");
      if (
        !editContact.contact_phone ||
        !phoneRegex.test(editContact.contact_phone)
      )
        return toast.error("Invalid phone format.");
      // if (!editContact.contact_mail || !emailRegex.test(editContact.contact_mail))
      //   return toast.error("Invalid email format.");
      if (!editContact.lead_from) return toast.error("Lead source is required.");

      const hasValidBranch = (editContact.branches || []).some(
        (b) =>
          b.branch_address ||
          b.branch_city ||
          b.branch_state ||
          b.branch_zipcode ||
          b.branch_country
      );
      if (!hasValidBranch)
        return toast.error(
          "At least one branch must have valid address details."
        );

      try {
        await updateCompany(editContact.contact_id, {
          company_name: editContact.contact_Company_name,
          company_mail: editContact.contact_mail,
          website_url: editContact.website_url,
          company_phone: editContact.contact_phone,
          contact_remark: editContact.contact_description,
          contact_person_name: editContact.contact_name,
          contact_person_desigination: editContact.contact_desigination,
          leadsource_id: editContact.lead_from,
          branches: editContact.branches || [],
          leadgivenby_id: editContact.leadgivenby_id || "",
        });
        dispatch(loadContacts());
        handleCloseEditModal();
        toast.success("Contact updated successfully");
      } catch (error) {
        toast.error("Failed to update contact");
      }
    }, [editContact, dispatch]);

    const handleDeleteContact = useCallback(async () => {
      if (!contactToDelete) return;
      setDeleting(true);
      try {
        const result = await dispatch(deleteContact(contactToDelete));
        if (deleteContact.fulfilled.match(result)) {
          toast.success("Company deleted successfully!");
          setContactToDelete(null);
        } else {
          toast.error(
            typeof result.payload === "string"
              ? result.payload
              : "Failed to delete contact"
          );
        }
      } catch (err) {
        console.error("Unexpected error", err);
        toast.error("Unexpected error while deleting contact");
      } finally {
        setDeleting(false);
      }
    }, [contactToDelete, dispatch]);

    // const handleColumnToggle = useCallback(
    //   (columnKey: keyof typeof visibleColumns) => {
    //     const updated = {
    //       ...visibleColumns,
    //       [columnKey]: !visibleColumns[columnKey],
    //     };
    //     setVisibleColumns(updated);
    //     localStorage.setItem("visibleColumns", JSON.stringify(updated));
    //   },
    //   [visibleColumns]
    // );
    // Column order state for drag and drop (only non-sticky columns)
    const [columnKeys, setColumnKeys] = useState<string[]>(() => {
      const saved = localStorage.getItem("contactColumnKeys");
      if (saved) {
        const parsed = JSON.parse(saved);
        // Migration: Map old keys to new keys if detected
        const keyMap: Record<string, string> = {
          contact_phone: "phone",
          contact_mail: "email",
          contact_desigination: "designation",
          contact_Company_name: "company",
          website_url: "website",
          contact_description: "description",
          eta_page: "meta_page" // assuming eta_page was meta_page
        };
        return parsed.map((k: string) => keyMap[k] || k);
      }
      return defaultColumnOrder;
    });

    // Hook for save prompt on navigation/refresh
    const { SaveModal } = useColumnOrderSave({
      columnKeys,
      localStorageKey: "contactColumnKeys",
      defaultOrder: defaultColumnOrder,
    });

    const handleColumnToggle = useCallback((columnKey: string) => {
      setVisibleColumns((prev: any) => ({
        ...prev,
        [columnKey]: !prev[columnKey],
      }));
    }, []);

    useEffect(() => {
      localStorage.setItem("visibleColumns", JSON.stringify(visibleColumns));
    }, [visibleColumns]);
    const handleResetColumns = useCallback(() => {
      setVisibleColumns(defaultVisibleColumns);
      localStorage.setItem(
        "visibleColumns",
        JSON.stringify(defaultVisibleColumns)
      );
    }, []);

      const [showCustomExportModal, setShowCustomExportModal] = useState(false);

    useEffect(() => {
      if (!showCustomExportModal) return;

      setTimeout(() => {
        const modal = document.getElementById("custom_export_modal");
        if (modal) setupDraggable(modal);
      }, 100);
    }, [showCustomExportModal]);

    useLayoutEffect(() => {
      if (showCustomExportModal) {
        const modal = document.getElementById("custom_export_modal");
        if (modal) restoreModalPosition(modal);
      }
    });
    useEffect(() => {
  const offcanvasElement = document.getElementById('offcanvas_add');
  
  const handleOffcanvasShow = () => {
    // Fetch users when Add Contact modal opens
    const clientId = localStorage.getItem("client_id") || 
                     contacts[0]?.client_id || 
                     "";
    if (clientId) {
      fetchUsers(clientId);
    }
  };

  offcanvasElement?.addEventListener('show.bs.offcanvas', handleOffcanvasShow);

  return () => {
    offcanvasElement?.removeEventListener('show.bs.offcanvas', handleOffcanvasShow);
  };
}, [fetchUsers, contacts]);
    const [exportColumns, setExportColumns] = useState({
      company_name: false,
      company_phone: false,
      company_mail: false,
      contact_person_name: false,
      contact_person_designation: false,
      website_url: false,
      company_remark: false,
      lead_source_name: false,
      lead_owner_name: false,
      created_at: false,
      branch_name: false,
      branch_city: false,
      branch_state: false,
      branch_country: false,
      gst_number: false,
    });

    // Handle column selection for export
    const handleExportColumnToggle = (columnKey: keyof typeof exportColumns) => {
      setExportColumns((prev) => ({
        ...prev,
        [columnKey]: !prev[columnKey],
      }));
    };
    const hasSelectedExportColumn = Object.values(exportColumns).some(Boolean);
    const allColumnsSelected = Object.values(exportColumns).every(Boolean);
    // Handle customized export (PDF or Excel)
    const handleCustomExport = async (format: "pdf" | "excel") => {
      if (selectedContacts.length === 0) {
        toast.error("Please select at least one contact to export.");
        return;
      }

      const selectedFields = Object.entries(exportColumns)
        .filter(([_, value]) => value)
        .map(([key]) => key)
        .join(",");

      if (!selectedFields) {
        toast.warning("Please select at least one column to export.");
        return;
      }

      try {
        const response =
          format === "pdf"
            ? await exportContactsPdfCustomized(selectedFields, selectedContacts)
            : await exportContactsExcelCustomized(
              selectedFields,
              selectedContacts
            );

        const mimeType =
          format === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

        const blob = new Blob([response], { type: mimeType });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Custom_Contacts.${format === "pdf" ? "pdf" : "xlsx"}`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        setShowCustomExportModal(false);
        toast.success(
          `Contacts exported as ${format.toUpperCase()} successfully!`
        );
      } catch (error) {
        toast.error(`Failed to export contacts as ${format.toUpperCase()}`);
        console.error(error);
      }
    };

    const uniqueNames = useMemo(
      () =>
        Array.from(new Set(contacts.map((c) => c.contact_name || ""))).filter(
          (n) => n
        ),
      [contacts]
    );
    const uniqueCompanies = useMemo(
      () =>
        Array.from(
          new Set(contacts.map((c) => c.contact_Company_name || ""))
        ).filter((n) => n),
      [contacts]
    );
    const uniqueDesignations = useMemo(
      () =>
        Array.from(
          new Set(contacts.map((c) => c.contact_desigination || ""))
        ).filter((n) => n),
      [contacts]
    );
    const uniqueOwners = useMemo(
      () =>
        Array.from(
          new Set(contacts.map((c) => c.username || "Unassigned"))
        ).filter((n) => n),
      [contacts]
    );
    const uniqueLeadSources = useMemo(
      () =>
        Array.from(new Set(contacts.map((c) => c.leadsource_name || ""))).filter(
          (n) => n
        ),
      [contacts]
    );
    const uniqueLeadGivenBy = useMemo(
      () =>
        Array.from(new Set(contacts.map((c) => c.leadgivenby_name || ""))).filter(
          (n) => n
        ),
      [contacts]
    );

    const uniquePhones = useMemo(
      () =>
        Array.from(new Set(contacts.map((c) => c.contact_phone || ""))).filter(
          (n) => n
        ),
      [contacts]
    );
    const uniqueEmails = useMemo(
      () =>
        Array.from(new Set(contacts.map((c) => c.contact_mail || ""))).filter(
          (n) => n
        ),
      [contacts]
    );
    const usersByName = useMemo(() => {
      const map: Record<string, User> = {};

      users.forEach((u) => {
        if (u.name) {
          map[u.name.trim().toLowerCase()] = u;
        }
      });

      return map;
    }, [users]);

    const handleFilterChange = useCallback(
      (
        value: string,
        list: string[],
        setList: React.Dispatch<React.SetStateAction<string[]>>
      ) => {
        if (list.includes(value)) {
          setList(list.filter((item) => item !== value));
        } else {
          setList([...list, value]);
        }
      },
      []
    );

    const allColumns: ColumnsType<Contact> = useMemo(() => {
        const columnDefs: Record<string, any> = {
          // name: {
          //   title: (
          //     <div
          //       className="flex items-center justify-between"
          //       style={{ height: 22, whiteSpace: "nowrap" }}
          //       onClick={(e) => e.stopPropagation()}
          //     >
          //       <span className="me-2">Contact Name</span>
          //        <Dropdown
          //         trigger={["click"]}
          //         onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)}
          //         overlay={
          //           <Menu
          //             selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
          //             onClick={({ key }) => setAlphaFilter(key === "All" ? "" : key)}
          //             style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          //           >
          //             <Menu.Item key="All" className="text-center">
          //               All
          //             </Menu.Item>
          //             {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
          //               <Menu.Item key={letter} className="text-center">
          //                 {letter}
          //               </Menu.Item>
          //             ))}
          //           </Menu>
          //         }
          //       >
          //         <AntButton
          //           size="small"
          //           type="text"
          //           onClick={(e) => e.stopPropagation()}
          //           style={{
          //             fontSize: 12,
          //             height: 17,
          //             padding: "0 8px",
          //             border: "1px solid #d9d9d9",
          //             background: "#fafafa",
          //           }}
          //         >
          //           {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
          //           <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
          //         </AntButton>
          //       </Dropdown>
          //     </div>
          //   ),
          //   dataIndex: "contact_Company_name",
          //   key: "name",
          //   sorter: (a: Contact, b: Contact) =>
          //     (a.contact_Company_name || "").localeCompare(
          //       b.contact_Company_name || ""
          //     ) || 0,
          //   render: (text: string, record: Contact) => {
          //     const initial = text?.charAt(0)?.toUpperCase() || "";
          //     const contactName = record.contact_name || "N/A";
          //     return (
          //       <div className="d-flex align-items-center gap-2">
          //         <Avatar
          //           shape="square"
          //           onClick={() => handleEditContact(record)}
          //           style={{
          //             backgroundColor: "#ff4d4f",
          //             border: "2px solid #ff4d4f",
          //             width: 36,
          //             height: 36,
          //             fontSize: 16,
          //             fontWeight: 600,
          //             cursor: "pointer",
          //           }}
          //         >
          //           {initial}
          //         </Avatar>
          //         <div className="d-flex flex-column">
          //           <strong>
          //             {highlightMatch(text?.trim() || "N/A", searchQuery)}
          //           </strong>
          //           <span className="text-muted">
          //             {highlightMatch(contactName || "N/A", searchQuery)}
          //           </span>
          //         </div>
          //       </div>
          //     );
          //   },
          // },
          name: {
          title: (
            <div
              className="flex items-center justify-between"
              style={{ height: 22, whiteSpace: "nowrap" }}
              onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
            >
              <span className="me-2">Contact Name</span>

              {/* Ant Design Dropdown – pure, tiny, beautiful */}
              <Dropdown
                trigger={["click"]}
                onOpenChange={(open) =>
                  open && setTimeout(() => document.body.click(), 0)
                } // optional: close on outside click
                overlay={
                  <Menu
                    selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
                    onClick={({ key }) =>
                      setAlphaFilter(key === "All" ? "" : key)
                    }
                    style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                  >
                    <Menu.Item key="All" className="text-center">
                      All
                    </Menu.Item>
                    {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                      <Menu.Item key={letter} className="text-center">
                        {letter}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    fontSize: 12,
                    height: 17,
                    padding: "0 8px",
                    border: "1px solid #d9d9d9",
                    
                  }}
                >
                  {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
                  <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
                </Button>
              </Dropdown>
            </div>
          ),
          dataIndex: "contact_Company_name",
          key: "name",
          fixed: "left",
          sorter: (a: Contact, b: Contact) =>
            (a.contact_Company_name || "").localeCompare(
              b.contact_Company_name || ""
            ),
          render: (text: string, record: Contact) => {
            const initial = text?.charAt(0)?.toUpperCase() || "";
            return (
              <Link
                to= "#"
                state={record}
                className="d-flex align-items-center gap-2"
              >
                <Avatar
                  shape="square"
                    onClick={() => handleEditContact(record)}
                    className="btn btn-primary"
                  style={{
                    width: 36,
                    height: 36,
                    fontSize: 16,
                    fontWeight: 600,
                      cursor: "pointer",
                  }}
                >
                  {initial || <UserOutlined />}
                </Avatar>

                <div className="d-flex flex-column">
                  <strong>
                    {highlightMatch(text?.trim() || "N/A", searchQuery)}
                  </strong>
                  <span className="text-muted">
                    {highlightMatch(
                      record.contact_name?.trim() || "N/A",
                      searchQuery
                    )}
                  </span>
                </div>
              </Link>
            );
          },
        },
          // phone: {
          //   title: "Phone",
          //   dataIndex: "contact_phone",
          //   key: "phone",
          //   sorter: (a: Contact, b: Contact) =>
          //     a.contact_phone?.localeCompare(b.contact_phone || "") || 0,
          //   render: (text: string) => (
          //     <span className="text-muted fw-semibold">
          //       {highlightMatch(text?.trim() || "N/A", searchQuery)}
          //     </span>
          //   ),
          // },
          phone : {
          title: "Phone",
          dataIndex: "contact_phone",
          key: "phone",
          sorter: (a: Contact, b: Contact) =>
            a.contact_phone?.localeCompare(b.contact_phone || "") || 0,
          render: (text: string) => (
            <TextCopy2
              text={text?.trim() || ""}
              searchQuery={searchQuery}
              showPhoneIcon={true}
            />
          ),
        },
          // email: {
          //   title: "Email",
          //   dataIndex: "contact_mail",
          //   key: "email",
          //   sorter: (a: Contact, b: Contact) =>
          //     a.contact_mail?.localeCompare(b.contact_mail || "") || 0,
          //   render: (text: string) =>
          //     highlightMatch(text?.trim() || "N/A", searchQuery),
          // },
          email :{
          title: "Email",
          dataIndex: "contact_mail",
          key: "email",
          sorter: (a: Contact, b: Contact) =>
            a.contact_mail?.localeCompare(b.contact_mail || "") || 0,
          render: (text: string) => (
            <TextCopy2
              text={text?.trim() || ""}
              searchQuery={searchQuery}
              showEmailIcon={true}
            />
          ),
        },
          designation: {
            title: "Designation",
            dataIndex: "contact_desigination",
            key: "designation",
            ellipsis: true,
            render: (text: string) =>
              highlightMatch(text?.trim() || "N/A", searchQuery),
          },
          company: {
            title: "Company",
            dataIndex: "contact_name",
            key: "company",
            render: (text: string) =>
              highlightMatch(text?.trim() || "N/A", searchQuery),
          },
          // username: {
          //    title: (
          //     <div
          //       className="flex items-center justify-between"
          //       style={{ height: 28, whiteSpace: "nowrap" }}
          //       onClick={(e) => e.stopPropagation()}
          //     >
          //       <span className="me-2">Lead Owner</span>

          // <Dropdown
          //   trigger={["click"]}
          //   overlay={
          //     <Menu
          //       selectedKeys={[assignmentFilter]}
          //       onClick={({ key }) => setAssignmentFilter(key)}
          //       style={{ width: 150 }}
          //     >
          //       <Menu.Item key="all">
          //         <FilterOutlined style={{ marginRight: 8,
          //         color: "#4000a6ff",
          //       }}
          //     /> All
          //       </Menu.Item>
          //       <Menu.Item key="assigned">
          //         <UserOutlined style={{ marginRight: 8,
          //         color: "#30bc20ff",
          //       }}
          //     /> Assigned
          //       </Menu.Item>
          //       <Menu.Item key="unassigned">
          //         <UserDeleteOutlined style={{ marginRight: 8,
          //         color: "#f1000cff",
          //       }}/> Unassigned
          //       </Menu.Item>
          //     </Menu>
          //   }
          // >
          //   <AntButton
          //     size="small"
          //     type="text"
          //     onClick={(e) => e.stopPropagation()}
          //     style={{ padding: "1 6px" }}
          //   >
          //     <FunnelPlotFilled
          //       style={{
          //         fontSize: 15,
          //         height: 17,
          //         color: assignmentFilter && assignmentFilter !== "all" ? "#1890ff" : "#000",
          //       }}
          //     />
          //   </AntButton>
          // </Dropdown>

          //       <Dropdown
          //         trigger={["click"]}
          //         onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)}
          //         overlay={
          //           <Menu
          //             selectedKeys={alphaFilterleadowner ? [alphaFilterleadowner] : ["All"]}
          //             onClick={({ key }) => setAlphaFilterleadowner(key === "All" ? "" : key)}
          //             style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          //           >
          //             <Menu.Item key="All" className="text-center">
          //               All
          //             </Menu.Item>
          //             {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
          //               <Menu.Item key={letter} className="text-center">
          //                 {letter}
          //               </Menu.Item>
          //             ))}
          //           </Menu>
          //         }
          //       >
          //         <AntButton
          //           size="small"
          //           type="text"
          //           onClick={(e) => e.stopPropagation()}
          //           style={{
          //             fontSize: 12,
          //             height: 17,
          //             padding: "0 8px",
          //             border: "1px solid #d9d9d9",
          //             background: "#fafafa",
          //           }}
          //         >
          //           {alphaFilterleadowner ? alphaFilterleadowner.toUpperCase() : "ALL"}
          //           <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
          //         </AntButton>
          //       </Dropdown>
          //     </div>
          //   ),
          //   dataIndex: "username",
          //   key: "username",
          //   render: (text: string) =>
          //     highlightMatch(text?.trim() || "Unassigned", searchQuery),
          // },
            username : {
          title: (
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ height: 28, whiteSpace: "nowrap" }}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="me-2">Lead Owner</span>

              {/* Assignment Filter Dropdown with Counts */}
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu
                    selectedKeys={[assignmentFilter]}
                    onClick={({ key }) => setAssignmentFilter(key as any)}
                    style={{ width: 180 }}
                  >
                    <Menu.Item
                      key="all"
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>
                        <FilterOutlined
                          style={{ marginRight: 8, color: "#4000a6" }}
                        />
                        All
                      </span>
                      <span className="badge bg-secondary-light  rounded-pill ms-3">
                        {assignmentCounts.all.toLocaleString()}
                      </span>
                    </Menu.Item>

                    <Menu.Item
                      key="assigned"
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>
                        <UserOutlined
                          style={{ marginRight: 8, color: "#30bc20" }}
                        />
                        Assigned
                      </span>
                      <span className="badge bg-success-light  rounded-pill ms-3">
                        {assignmentCounts.assigned.toLocaleString()}
                      </span>
                    </Menu.Item>

                    <Menu.Item
                      key="unassigned"
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>
                        <UserDeleteOutlined
                          style={{ marginRight: 8, color: "#f1000c" }}
                        />
                        Unassigned
                      </span>
                      <span className="badge bg-danger-light  rounded-pill ms-3">
                        {assignmentCounts.unassigned.toLocaleString()}
                      </span>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  className="me-1"
                >
                  <FunnelPlotFilled
                    style={{
                      fontSize: 15,
                      color:
                        assignmentFilter && assignmentFilter !== "all"
                          ? "#1890ff"
                          : "#666",
                    }}
                  />
                  {/* Optional: show current count on button */}
                  {assignmentFilter !== "all" && (
                    <span className="ms-1 small fw-semibold ">
                      {
                        assignmentCounts[
                        assignmentFilter as keyof typeof assignmentCounts
                        ]
                      }
                    </span>
                  )}
                </Button>
              </Dropdown>

              {/* Alphabetical Filter (kept as-is) */}
              <Dropdown
                trigger={["click"]}
                onOpenChange={(open) =>
                  open && setTimeout(() => document.body.click(), 0)
                }
                overlay={
                  <Menu
                    selectedKeys={
                      alphaFilterleadowner ? [alphaFilterleadowner] : ["All"]
                    }
                    onClick={({ key }) =>
                      setAlphaFilterleadowner(key === "All" ? "" : key)
                    }
                    style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                  >
                    <Menu.Item key="All" className="text-center">
                      All
                    </Menu.Item>
                    {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                      <Menu.Item key={letter} className="text-center">
                        {letter}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    fontSize: 12,
                    height: 17,
                    padding: "0 10px",
                    border: "1px solid #d9d9d9",
                  
                  }}
                >
                  {alphaFilterleadowner
                    ? alphaFilterleadowner.toUpperCase()
                    : "ALL"}
                  <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
                </Button>
              </Dropdown>
            </div>
          ),
          dataIndex: "username",
          key: "username",
          render: (_: string, record: Contact) => {
            const owner =
              usersByName[record.username?.trim().toLowerCase() || ""];

            return (
              <span onClick={(e) => e.stopPropagation()}>
                <LeadOwnerHoverCard
                  name={highlightMatch(
                    record.username?.trim() || "Unassigned",
                    searchQuery
                  )}
                  leadowner_name={record.username} // ✅ REQUIRED FOR NAVIGATION
                  company_name={record.contact_Company_name} // ✅ REQUIRED FOR NAVIGATION
                  role={owner?.role}
                  email={owner?.email}
                  phone={owner?.phone_no}
                />
              </span>
            );
          },
        },
          website: {
            title: "Website",
            dataIndex: "website_url",
            key: "website",
              render: (text: string) => (
            <TextCopy2
              text={text?.trim() || ""}
              searchQuery={searchQuery}
              showWebsiteIcon={true}
            />
          ),
          },
          // leadsource_name: {
          //      title: (
          //     <div
          //       className="flex items-center justify-between"
          //       style={{ height: 28, whiteSpace: "nowrap" }}
          //       onClick={(e) => e.stopPropagation()}
          //     >
          //       <span className="me-2">Lead Source</span>

          //       <Dropdown
          //   trigger={["click"]}
          //   overlay={
          //     <Menu
          //       selectedKeys={filterLeadSources}
          //       style={{ width: 200, maxHeight: 260, overflowY: "auto" }}
          //     >
          //       <Menu.Item
          //         key="all"
          //         onClick={() => setFilterLeadSources([])}
          //       >
          //         <Checkbox checked={filterLeadSources.length === 0}>
          //           All Lead Sources
          //         </Checkbox>
          //       </Menu.Item>

          //       {uniqueLeadSources.map((src) => {
          //         const isChecked = filterLeadSources.includes(src);

          //         return (
          //           <Menu.Item
          //             key={src}
          //             onClick={() => {
          //               setFilterLeadSources((prev) =>
          //                 isChecked
          //                   ? prev.filter((v) => v !== src)
          //                   : [...prev, src]
          //               );
          //             }}
          //           >
          //             <Checkbox checked={isChecked}>{src}</Checkbox>
          //           </Menu.Item>
          //         );
          //       })}
          //     </Menu>
          //   }
          // >
          //   <AntButton
          //     size="small"
          //     type="text"
          //     style={{ padding: "0 6px" }}
          //     onClick={(e) => e.stopPropagation()}
          //   >
          //     <FunnelPlotFilled
          //       style={{ fontSize: 15, height: 17, color: filterLeadSources.length > 0 ? "#1890ff" : "#000" }}
          //     />
          //   </AntButton>
          // </Dropdown>
                
          //       <Dropdown
          //         trigger={["click"]}
          //         onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)}
          //         overlay={
          //           <Menu
          //             selectedKeys={alphaFilterleadsource ? [alphaFilterleadsource] : ["All"]}
          //             onClick={({ key }) => setAlphaFilterleadsource(key === "All" ? "" : key)}
          //             style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          //           >
          //             <Menu.Item key="All" className="text-center">
          //               All
          //             </Menu.Item>
          //             {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
          //               <Menu.Item key={letter} className="text-center">
          //                 {letter}
          //               </Menu.Item>
          //             ))}
          //           </Menu>
          //         }
          //       >
          //         <AntButton
          //           size="small"
          //           type="text"
          //           onClick={(e) => e.stopPropagation()}
          //           style={{
          //             fontSize: 12,
          //             height: 17,
          //             padding: "0 8px",
          //             border: "1px solid #d9d9d9",
          //             background: "#fafafa",
          //           }}
          //         >
          //           {alphaFilterleadsource ? alphaFilterleadsource.toUpperCase() : "ALL"}
          //           <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
          //         </AntButton>
          //       </Dropdown>
          //     </div>
          //   ),
          //   dataIndex: "leadsource_name",
          //   key: "leadsource_name",
          //   render: (text: string) => (
          //     <span className="text-muted fw-semibold">
          //       {highlightMatch(text?.trim() || "N/A", searchQuery)}
          //     </span>
          //   ),
          // },
          leadsource_name :  {
          title: (
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ height: 28, whiteSpace: "nowrap" }}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="me-2">Lead Source</span>

              {/* Lead Source Multi Filter Dropdown with Counts (No Colors) */}
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu
                    selectedKeys={filterLeadSources}
                    style={{ width: 240, maxHeight: 300, overflowY: "auto" }}
                    onClick={(e) => e.domEvent.stopPropagation()} // prevent table sort
                  >
                    {/* All Lead Sources */}
                    <Menu.Item
                      key="all"
                      onClick={() => setFilterLeadSources([])}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <Checkbox checked={filterLeadSources.length === 0}>
                        All Lead Sources
                      </Checkbox>
                      <span className="text-muted small ms-3">
                        ({leadSourceCounts.all.toLocaleString()})
                      </span>
                    </Menu.Item>

                    <Menu.Divider />

                    {/* Dynamic Lead Sources with Checkbox + Count */}
                    {uniqueLeadSources.map((src) => {
                      const isChecked = filterLeadSources.includes(src);
                      const count = leadSourceCounts[src] || 0;

                      return (
                        <Menu.Item
                          key={src}
                          onClick={() => {
                            setFilterLeadSources((prev) =>
                              isChecked
                                ? prev.filter((v) => v !== src)
                                : [...prev, src]
                            );
                          }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <Checkbox checked={isChecked}>
                            {src || "Unknown"}
                          </Checkbox>
                          <span className="text-muted small ms-3">
                            ({count.toLocaleString()})
                          </span>
                        </Menu.Item>
                      );
                    })}
                  </Menu>
                }
              >
                <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  className="me-1"
                >
                  <FunnelPlotFilled
                    style={{
                      fontSize: 15,
                      color: filterLeadSources.length > 0 ? "#1890ff" : "#666",
                    }}
                  />
                  
                  {/* Optional: show selected count */}
                  {filterLeadSources.length > 0 && (
                    <span className="ms-1 small fw-semibold">
                      {filterLeadSources.length}
                    </span>
                  )}
                </Button>
              </Dropdown>

              {/* Alphabetical A-Z Filter (unchanged) */}
              <Dropdown
                trigger={["click"]}
                onOpenChange={(open) =>
                  open && setTimeout(() => document.body.click(), 0)
                }
                overlay={
                  <Menu
                    selectedKeys={
                      alphaFilterleadsource ? [alphaFilterleadsource] : ["All"]
                    }
                    onClick={({ key }) =>
                      setAlphaFilterleadsource(key === "All" ? "" : key)
                    }
                    style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                  >
                    <Menu.Item key="All" className="text-center">
                      All
                    </Menu.Item>
                    {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                      <Menu.Item key={letter} className="text-center">
                        {letter}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    fontSize: 12,
                    height: 17,
                    padding: "0 10px",
                    border: "1px solid #d9d9d9",
                    
                  }}
                >
                  {alphaFilterleadsource
                    ? alphaFilterleadsource.toUpperCase()
                    : "ALL"}
                  <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
                </Button>
              </Dropdown>
            </div>
          ),
          dataIndex: "leadsource_name",
          key: "leadsource_name",
          render: (text: string) => (
            <span className="text-muted fw-semibold">
              {highlightMatch(text?.trim() || "N/A", searchQuery)}
            </span>
          ),
        },
          leadgivenby_name: {
              title: (
              <div
                className="flex items-center justify-between"
                style={{ height: 28, whiteSpace: "nowrap" }}
                onClick={(e) => e.stopPropagation()}
              >
                <span className="me-2">Lead Given By</span>

                <Dropdown
            trigger={["click"]}
            overlay={
              <Menu
                selectedKeys={filterLeadGivenBy}
                style={{ width: 200, maxHeight: 260, overflowY: "auto" }}
              >
                <Menu.Item
                  key="all"
                  onClick={() => setFilterLeadGivenBy([])}
                >
                  <Checkbox checked={filterLeadGivenBy.length === 0}>
                    All Lead Given By
                  </Checkbox>
                </Menu.Item>

                {uniqueLeadGivenBy.map((src) => {
                  const isChecked = filterLeadGivenBy.includes(src);

                  return (
                    <Menu.Item
                      key={src}
                      onClick={() => {
                        setFilterLeadGivenBy((prev) =>
                          isChecked
                            ? prev.filter((v) => v !== src)
                            : [...prev, src]
                        );
                      }}
                    >
                      <Checkbox checked={isChecked}>{src}</Checkbox>
                    </Menu.Item>
                  );
                })}
              </Menu>
            }
          >
              <Button
                  size="sm"
                  type="submit"
                  onClick={(e) => e.stopPropagation()}
                  className="me-1"
                >
              <FunnelPlotFilled
                style={{ fontSize: 15, height: 17, color: filterLeadGivenBy.length > 0 ? "#1890ff" : "#000" }}
              />
            </Button>
          </Dropdown>
                <Dropdown
                  trigger={["click"]}
                  onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)}
                  overlay={
                    <Menu
                      selectedKeys={alphaFilterleadgiven ? [alphaFilterleadgiven] : ["All"]}
                      onClick={({ key }) => setAlphaFilterleadgiven(key === "All" ? "" : key)}
                      style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                    >
                      <Menu.Item key="All" className="text-center">
                        All
                      </Menu.Item>
                      {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                        <Menu.Item key={letter} className="text-center">
                          {letter}
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <AntButton
                    size="small"
                    type="text"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      fontSize: 12,
                      height: 17,
                      padding: "0 8px",
                      border: "1px solid #d9d9d9",
                      
                    }}
                  >
                    {alphaFilterleadgiven ? alphaFilterleadgiven.toUpperCase() : "ALL"}
                    <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
                  </AntButton>
                </Dropdown>
              </div>
            ),
            dataIndex: "leadgivenby_name",
            key: "leadgivenby_name",
            render: (text: string) => (
              <span className="text-muted fw-semibold">
                {highlightMatch(text?.trim() || "N/A", searchQuery)}
              </span>
            ),
          },
          // description: {
          //   title: "Remarks",
          //   dataIndex: "contact_description",
          //   key: "description",
          //   render: (text: string) =>
          //     highlightMatch(text?.trim() || "N/A", searchQuery),
          // },
          description :{
          title: "Remarks",
          dataIndex: "contact_description",
          key: "description",
          ellipsis: true,
          render: (text: string) => {
            const value = text?.trim() || "N/A";

            return (
              <span
                className="text-truncate"
                style={{
                  display: "inline-block",
                  maxWidth: 180,        // 👈 REQUIRED
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {highlightMatch(value, searchQuery)}
              </span>
            );
          },
        },
        created_at: {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            render: (date: string) => {
              const parsed = new Date(date);
              if (!date || isNaN(parsed.getTime())) return "-";
              const dateStr = parsed.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              });
              const timeStr = parsed.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              });

              return (
                <div>
                  <div>{dateStr}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>{timeStr}</div>
                </div>
              );
            },
          }
        };

        const columns: ColumnsType<Contact> = [
          {
            title: "S.No",
            key: "index",
            render: (_text: any, _record: any, index: number) =>
              (currentPage - 1) * pageSize + index + 1,
          }
        ];

        columnKeys.forEach((key) => {
          if (visibleColumns[key] && columnDefs[key]) {
            columns.push(columnDefs[key]);
          }
        });
        
      if (visibleColumns.actions) {
          columns.push({
          title: "Actions",
            dataIndex: "actions",
            key: "actions",
            fixed: "right",
          render: (_: any, record: Contact) => {
            const menu = (
              <Menu
                onClick={(e) => e.domEvent.stopPropagation()}
                style={{
                  minWidth: 220,
                  borderRadius: 8,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <Menu.Item
                  key="view-details"
                  onClick={() => {
                    setSelectedContactForView(record);
                    setShowViewDetailsModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <i className="ti ti-eye text-primary me-2 fs-15" />
                  <span>View Details</span>
                </Menu.Item>

                <Menu.Item
                  key="assign"
                  data-bs-toggle="modal"
                  data-bs-target="#assign_user_modal"
                  onClick={() => {
                    handleOpenAssignModal(record);
                  }}
                >
                  <i className="ti ti-user-plus text-info me-2" />
                  Assign User
                </Menu.Item>

                <Menu.Item
                  key="edit"
                  onClick={() => handleEditContact(record)}

                  className="d-flex align-items-center"
                >
                  <i className="ti ti-edit text-primary me-2 fs-15" />
                  <span>Edit Contact</span>
                </Menu.Item>

                <Menu.Item
                  key="delete"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_contact"
                  onClick={() => setContactToDelete(record.contact_id)}
                  className="d-flex align-items-center text-danger"
                >
                  <i className="ti ti-trash text-danger me-2 fs-15" />
                  <span>Delete Contact</span>
                </Menu.Item>

                <Menu.Divider />

                <Menu.Item
                  key="pdf"
                  onClick={() => handleExportAsPDF(record)}
                  className="d-flex align-items-center"
                >
                  <i className="ti ti-file-type-pdf text-danger me-2 fs-15" />
                  <span>Export as PDF</span>
                </Menu.Item>

                <Menu.Item
                  key="excel"
                  onClick={() => handleExportAsExcel(record)}
                  className="d-flex align-items-center"
                >
                  <i className="ti ti-file-type-xls text-success me-2 fs-15" />
                  <span>Export as Excel</span>
                </Menu.Item>

                <Menu.Item
                  key="custom-excel"
                  onClick={() => {
                    //setSelectedExportContacts([record.contact_id]);
                    setShowCustomExportModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <i className="ti ti-file-spreadsheet text-warning me-2 fs-15" />
                  <span>Customized Export</span>
                </Menu.Item>
              </Menu>
            );

            return (
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="table-actions-dropdown"
                onOpenChange={(open) => {
                  if (open) {
                    // Prevent row click when dropdown opens
                    setTimeout(() => document.body.click(), 0);
                  }
                }}
              >
                <Button
                  //type="dashed"
                  size="sm"
                  type="button"
                  className="table-action-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  <i className="ti ti-dots-vertical fs-14" />
                </Button>
              </Dropdown>
            );
          },
        });
      }
      return columns;
      },
      [
        visibleColumns,
        columnKeys,
        searchQuery,
        currentPage,
        pageSize,
        alphaFilter,
        alphaFilterleadowner,
        alphaFilterleadsource,
        alphaFilterleadgiven,
        handleEditContact,
        handleOpenAssignModal,
        filterLeadSources,
        uniqueLeadSources,
        filterLeadGivenBy,
        uniqueLeadGivenBy,
        assignmentFilter
      ]
    );

    useEffect(() => {
      const timer = setTimeout(() => setDebouncedSearchQuery(searchQuery), 300);
      return () => clearTimeout(timer);
    }, [searchQuery]);
    
    const handleRowOrderChange = (newOrdered: Contact[]) => {
      setOrderedData(newOrdered);
      // OPTIONAL: persist to backend
      // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
    };

    const updateAddressField = useCallback(
      (index: number, field: string, value: string) => {
        setAddresses((prev) => {
          const updated = [...prev];
          (updated[index] as any)[field] = value;
          return updated;
        });
      },
      []
    );

    const addNewAddress = useCallback(() => {
      setAddresses((prev) => [
        ...prev,
        {
          branch_name: "",
          contact_address: "",
          contact_city: "",
          contact_state: "",
          contact_zipcode: "",
          contact_country: "",
          gst_number: "",
        },
      ]);
    }, []);

    const removeAddress = useCallback((index: number) => {
      setAddresses((prev) => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });
    }, []);

    const updateBranchField = useCallback(
      (index: number, field: string, value: string) => {
        if (!editContact || !editContact.branches) return;
        const updatedBranches = [...editContact.branches];
        updatedBranches[index] = { ...updatedBranches[index], [field]: value };
        setEditContact({ ...editContact, branches: updatedBranches });
      },
      [editContact]
    );

    const renderBranchFields = useCallback(
      (branchData: any, index: number, isSingleMode = false) => (
        <div className="row">
          <h6 className="mt-3 mb-3 border-bottom pb-1">
            <i className="ti ti-file-description me-2 text-primary" />
            Additional Info
          </h6>
          {[
            { label: "Branch Name", key: "branch_name" },
            { label: "Address", key: "branch_address" },
            { label: "City", key: "branch_city" },
            { label: "State", key: "branch_state" },
            { label: "Country", key: "branch_country" },
            { label: "Zipcode", key: "branch_zipcode" },
            { label: "GST Number", key: "gst_number" },
          ].map((field) => (
            <div className="col-md-6 mb-3" key={field.key}>
              <label className="col-form-label">{field.label}</label>
              <input
                type="text"
                className="form-control"
                value={branchData?.[field.key] || ""}
                onChange={(e) => {
                  const updated = [...(editContact?.branches || [])];
                  if (isSingleMode) {
                    const single = {
                      ...(updated[0] || {}),
                      [field.key]: e.target.value,
                    };
                    setEditContact({ ...editContact!, branches: [single] });
                  } else {
                    updated[index] = {
                      ...updated[index],
                      [field.key]: e.target.value,
                    };
                    setEditContact({ ...editContact!, branches: updated });
                  }
                }}
              />
            </div>
          ))}
        </div>
      ),
      [editContact]
    );

    const handleImportProcess = async () => {
      const error = validateImportName(importReferenceName);
      if (error) {
        setImportNameError(error);
        toast.error("Please fix Import Name");
        return;
      }

      if (!importFile || !importReferenceName.trim()) {
        toast.error("Please provide an import name and file.");
        return;
      }

      setIsSubmitting(true);

      try {
        const result = await checkDuplicateContacts(
          importFile,
          importReferenceName
        );

        if (result?.duplicates?.length > 0) {
          setDuplicates(result.duplicates);
          setImportSummary(result.summary || null); // optional: store summary early
          setShowImportModal(false);
          setShowDuplicateModal(true);
        } else {
          // No duplicates → import directly
          await proceedImportNonDuplicates();
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to check for duplicates");
        console.error(error);
      } finally {
        setIsSubmitting(false);
      }
    };

    const proceedImportNonDuplicates = async () => {
      setIsSubmitting(true);

      try {
        const result = await importNonDuplicateContacts(importReferenceName);

        // Optional: store summary if returned
        if (result?.summary) {
          setImportSummary(result.summary);
        }

        toast.success("Contacts imported successfully!");

        // ✅ RESET THE FORM COMPLETELY
        setImportReferenceName("");
        setImportFile(null);
        setImportNameError(undefined);
        setDuplicates([]);

        // Close any open import-related modal
        setShowDuplicateModal(false);
        setShowImportModal(false);

        // Show success modal
        setShowImportSuccessModal(true);

        // Refresh the contact list
        dispatch(loadContacts());
      } catch (error: any) {
        toast.error(error.message || "Failed to import contacts");
        console.error(error);
      } finally {
        setIsSubmitting(false);
      }
    };

    useEffect(() => {
      if (!showImportModal) return;

      setTimeout(() => {
        const modal = document.getElementById("import_contacts_modal");
        if (modal) setupDraggable(modal);
      }, 50);
    }, [showImportModal]);

    useLayoutEffect(() => {
      if (showImportModal) {
        const modal = document.getElementById("import_contacts_modal");
        if (modal) restoreModalPosition(modal);
      }
    });

    useEffect(() => {
      if (!showDuplicateModal) return;

      setTimeout(() => {
        const modal = document.getElementById("duplicate_contacts_modal");
        if (modal) setupDraggable(modal);
      }, 50);
    }, [showDuplicateModal]);

    useLayoutEffect(() => {
      if (showDuplicateModal) {
        const modal = document.getElementById("duplicate_contacts_modal");
        if (modal) restoreModalPosition(modal);
      }
    });

    useEffect(() => {
      if (!showImportSuccessModal) return;

      setTimeout(() => {
        const modal = document.getElementById("import_success_modal");
        if (modal) setupDraggable(modal);
      }, 50);
    }, [showImportSuccessModal]);

    useLayoutEffect(() => {
      if (showImportSuccessModal) {
        const modal = document.getElementById("import_success_modal");
        if (modal) restoreModalPosition(modal);
      }
    });

    const handleExportSelectedPDF = useCallback(async (contactIds: string[]) => {
      try {
        if (contactIds.length === 0) {
          toast.warning("No contacts selected for PDF export");
          return;
        }
        const response = await exportSelectedContactsPDF(contactIds);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Selected_Contacts.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        toast.error("Failed to export selected contacts as PDF");
      }
    }, []);

    const handleExportSelectedExcel = useCallback(
      async (contactIds: string[]) => {
        try {
          if (contactIds.length === 0) {
            toast.warning("No contacts selected for Excel export");
            return;
          }
          const response = await exportSelectedContactsExcel(contactIds);
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Selected_Contacts.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (err: any) {
          toast.error("Failed to export selected contacts as Excel");
        }
      },
      []
    );

    const handleExportAsPDF = useCallback(async (contact: Contact) => {
      try {
        if (!contact.contact_id) {
          toast.warning("Contact ID is missing for PDF export");
          return;
        }
        const response = await exportSelectedContactsPDF([contact.contact_id]);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Contact_${contact.contact_id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        toast.error("Failed to export contact as PDF");
        console.error(err);
      }
    }, []);

    const handleExportAsExcel = useCallback(async (contact: Contact) => {
      try {
        if (!contact.contact_id) {
          toast.warning("Contact ID is missing for Excel export");
          return;
        }
        const response = await exportSelectedContactsExcel([contact.contact_id]);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Contact_${contact.contact_id}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        toast.error("Failed to export contact as Excel");
        console.error(err);
      }
    }, []);

    const handleExportAllPDF = useCallback(async () => {
      try {
        if (contacts.length === 0) {
          toast.warning("No contacts available for PDF export");
          return;
        }
        const response = await exportContactsPDF();
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `All_Contacts.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        toast.error("Failed to export all contacts as PDF");
        console.error(err);
      }
    }, [contacts]);

    const handleExportAllExcel = useCallback(async () => {
      try {
        if (contacts.length === 0) {
          toast.warning("No contacts available for Excel export");
          return;
        }
        const response = await exportContactsExcel();
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `All_Contacts.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err: any) {
        toast.error("Failed to export all contacts as Excel");
        console.error(err);
      }
    }, [contacts]);

    const handleAccordionToggle = useCallback((sectionId: string) => {
      setOpenAccordion((prev) => (prev === sectionId ? null : sectionId));
    }, []);

    return (
      <>
        <PageLoadProgressBar />
        <div>
          <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="page-header mb-0">
                  <div className="row align-items-center">
                    <div className="col-8">
                      <h4 className="page-title">
                        <i className="ti ti-user-up text-primary me-2" />
                        Contacts
                        <span className="count-title ms-2">
                          <CountUp
                            end={contacts.length}
                            duration={3.0}
                            separator=","
                          />
                        </span>
                      </h4>
                    </div>
                    <div className="col-4 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Breadcrumb */}
                <nav
                  aria-label="breadcrumb"
                  className="page-header-breadcrumb mt-0 mb-3"
                >
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link
                        to={
                          userRole === "admin"
                            ? route.dealsDashboard
                            : route.leadsDashboard
                        }
                        style={{
                          color: "#9595b5",
                          textDecoration: "none",
                          transition: "color 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.color = "#E41F07")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.color = "#9595b5")
                        }
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Contacts
                    </li>
                  </ol>
                </nav>
                {/* /Breadcrumb */}
                <div className="card">
                  <div className="card-header">
                    <div className="row align-items-start">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="icon-form position-relative mb-3 sm-0 ms-3">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Contacts ..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                              paddingRight: searchQuery ? "60px" : "15px",
                            }} // Extra space for clear button
                          />

                          {/* Clear Button - Fixed & Visible */}
                          {searchQuery && (
                            <button
                              type="button"
                              className="position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                              style={{
                                zIndex: 10,
                                background: "none",
                                border: "none",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => setSearchQuery("")}
                              aria-label="Clear search"
                            >
                              <i className="ti ti-x fs-16" />
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-8 col-md-8 col-sm-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <Modal
                            show={showImportModal}
                            onHide={() => setShowImportModal(false)}
                            centered
                            dialogAs={(props) => (
                              <div {...props} id="import_contacts_modal" />
                            )}
                            className="effect-modal-show"
                          >
                            <div
                              id="import_contacts_modal"
                              className="modal fade show"
                              style={{ display: "block" }}
                            >
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title text-primary fw-bold">
                                      <i className="ti ti-file-import me-2" />
                                      Import Contacts
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                                      onClick={() => setShowImportModal(false)}
                                      aria-label="Close"
                                    >
                                      <i className="ti ti-x" />
                                    </button>
                                  </div>

                                  <div className="modal-body text-center mb-1">
                                    <div className="avatar avatar-xl bg-primary-light rounded-circle mx-auto mb-4 effect-modal-pulse">
                                      <i className="ti ti-file-upload fs-40 text-primary" />
                                    </div>

                                    <h4 className="fw-bold text-dark mb-3">
                                      Bulk Import Contacts via Excel
                                    </h4>

                                    <p className="text-muted fs-15 mb-2 px-4">
                                      Upload your Excel file to quickly add
                                      multiple contacts. The system will
                                      automatically detect and skip duplicates.
                                    </p>

                                    <div className="px-4">
                                      <div className="mb-3">
                                        <label className="form-label fw-medium text-start d-block">
                                          Import Reference Name{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className={`form-control form-control-lg ${importNameError ? "is-invalid" : ""
                                            }`}
                                          placeholder="e.g. Marketing Campaign - December 2025"
                                          value={importReferenceName}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            setImportReferenceName(val);
                                            setImportNameError(
                                              validateImportName(val)
                                            );
                                          }}
                                        />
                                        {importNameError && (
                                          <small className="text-danger text-start d-block mt-2">
                                            {importNameError}
                                          </small>
                                        )}
                                      </div>

                                      <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                          <label className="form-label fw-medium mb-0">
                                            Select Excel File{" "}
                                            <span className="text-danger">*</span>
                                          </label>
                                          <a
                                            href="/samplecontactdata.xlsx"
                                            download="samplecontactdata.xlsx"
                                            className="btn btn-sm btn-outline-success fw-medium"
                                          >
                                            <i className="ti ti-download me-1" />
                                            Sample Template
                                          </a>
                                        </div>
                                        <input
                                          type="file"
                                          className="form-control form-control-lg"
                                          accept=".xlsx,.xls"
                                          onChange={handleImportExcel}
                                        />
                                        {importFile && (
                                          <div className="alert alert-soft-success small py-2 mt-3 text-start">
                                            <i className="ti ti-check me-2" />
                                            File selected:{" "}
                                            <strong>{importFile.name}</strong>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="d-flex gap-3 justify-content-center mt-4">
                                      <button
                                        type="button"
                                        className="btn btn-light px-5 py-2 fw-medium"
                                        onClick={() => setShowImportModal(false)}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary px-5 py-2 fw-medium d-flex align-items-center gap-2"
                                        onClick={handleImportProcess}
                                        disabled={
                                          !importFile ||
                                          !!importNameError ||
                                          isSubmitting
                                        }
                                      >
                                        {isSubmitting ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                            />
                                            Processing File...
                                          </>
                                        ) : (
                                          <>
                                            <i className="ti ti-table-import me-2" />
                                            Start Import
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            show={showDuplicateModal}
                            onHide={() => setShowDuplicateModal(false)}
                            centered
                            dialogAs={(props) => (
                              <div {...props} id="duplicate_contacts_modal" />
                            )}
                          >
                            <div
                              id="duplicate_contacts_modal"
                              className="modal fade show"
                              style={{ display: "block" }}
                            >
                              <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title text-warning fw-bold">
                                      <i className="ti ti-alert-triangle me-2" />
                                      Duplicates Detected
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                                      onClick={() => setShowDuplicateModal(false)}
                                      aria-label="Close"
                                    >
                                      <i className="ti ti-x" />
                                    </button>
                                  </div>

                                  <div className="modal-body text-center py-4">
                                    <div className="avatar avatar-xl bg-warning-light rounded-circle mb-4 mx-auto">
                                      <i className="ti ti-alert-triangle fs-40 text-warning" />
                                    </div>

                                    <h4 className="fw-bold text-dark mb-3">
                                      {duplicates.length} Duplicate Contact
                                      {duplicates.length > 1 ? "s" : ""} Found
                                    </h4>

                                    <p className="text-muted fs-15 mb-4 px-4">
                                      The following contacts already exist in your
                                      database and will be skipped to avoid
                                      duplication.
                                    </p>

                                    <div className="table-responsive mx-4 mb-4">
                                      <table className="table table-bordered table-sm align-middle">
                                        <thead className="table-light">
                                          <tr>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Reason</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {duplicates.length === 0 ? (
                                            <tr>
                                              <td
                                                colSpan={3}
                                                className="text-center text-muted py-5"
                                              >
                                                No duplicates detected
                                              </td>
                                            </tr>
                                          ) : (
                                            duplicates.map((dup, index) => (
                                              <tr key={index}>
                                                <td
                                                  className="text-truncate"
                                                  style={{ maxWidth: "200px" }}
                                                >
                                                  {dup.company_mail || (
                                                    <em className="text-muted">
                                                      —
                                                    </em>
                                                  )}
                                                </td>
                                                <td>
                                                  {dup.company_phone || (
                                                    <em className="text-muted">
                                                      —
                                                    </em>
                                                  )}
                                                </td>
                                                <td>
                                                  <span className="badge bg-warning text-dark px-3 py-1">
                                                    {dup.reason ||
                                                      "Already Exists"}
                                                  </span>
                                                </td>
                                              </tr>
                                            ))
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <div className="d-flex gap-3 justify-content-center mt-4">
                                      <button
                                        type="button"
                                        className="btn btn-light px-5 py-2 fw-medium"
                                        onClick={() =>
                                          setShowDuplicateModal(false)
                                        }
                                      >
                                        Cancel Import
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-success px-5 py-2 fw-medium d-flex align-items-center gap-2"
                                        onClick={proceedImportNonDuplicates}
                                        disabled={isSubmitting}
                                      >
                                        {isSubmitting ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                            />
                                            Importing Remaining...
                                          </>
                                        ) : (
                                          <>
                                            <i className="ti ti-check me-2" />
                                            Import Non-Duplicates Only
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            show={showImportSuccessModal}
                            onHide={() => setShowImportSuccessModal(false)}
                            centered
                            dialogAs={(props) => (
                              <div {...props} id="import_success_modal" />
                            )}
                          >
                            <div
                              id="import_success_modal"
                              className="modal fade show"
                              style={{ display: "block" }}
                            >
                              <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title text-success fw-bold ">
                                      <i className="ti ti-file-upload me-2" />
                                      Contact Import Complete
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                                      onClick={() =>
                                        setShowImportSuccessModal(false)
                                      }
                                      aria-label="Close"
                                    >
                                      <i className="ti ti-x" />
                                    </button>
                                  </div>

                                  <div className="modal-body text-center py-4">
                                    {/* New Heading */}
                                    <div className="avatar avatar-xl bg-success-light rounded-circle mb-4 mx-auto">
                                      <i className="ti ti-check fs-40 text-success" />
                                    </div>

                                    <h4 className="fw-bold text-success mb-3">
                                      Import Completed Successfully!
                                    </h4>

                                    <p className="text-muted fs-15 mb-4 px-4">
                                      Your contacts have been successfully
                                      imported and are now available in the
                                      system.
                                    </p>

                                    {importSummary && (
                                      <div className="bg-light rounded-3 p-4 mb-5 mx-4">
                                        <p className="small text-muted mb-3 fw-medium">
                                          Import Summary
                                        </p>
                                        <div className="row g-4">
                                          <div className="col-6">
                                            <div className="text-center">
                                              <div className="fs-2 fw-bold text-success">
                                                {importSummary?.total_imported ||
                                                  0}
                                              </div>
                                              <small className="text-muted">
                                                New Contacts Added
                                              </small>
                                            </div>
                                          </div>
                                          <div className="col-6">
                                            <div className="text-center">
                                              <div className="fs-2 fw-bold text-warning">
                                                {importSummary?.total_non_duplicates ||
                                                  0}
                                              </div>
                                              <small className="text-muted">
                                                Duplicates Skipped
                                              </small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    <button
                                      type="button"
                                      className="btn btn-success px-5 py-2 fw-medium d-flex align-items-center gap-2 mx-auto"
                                      onClick={() => {
                                        setShowImportSuccessModal(false);
                                        dispatch(loadContacts());
                                      }}
                                    >
                                      <i className="ti ti-check me-2" />
                                      Done
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Modal>

                          <ModalDeleteEffect />
                          {/* Bulk Delete Confirmation Modal */}
                          {/* Bulk Delete Modal - Consistent Enhanced Style */}
                          <div
                            className="modal fade effect-modal-show"
                            id="bulk_delete_contacts"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="bulkDeleteContactsLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title text-danger fw-bold"
                                    id="bulkDeleteContactsLabel"
                                  >
                                    <i className="ti ti-alert-triangle me-2" />
                                    Confirm Bulk Deletion
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <i className="ti ti-x" />
                                  </button>
                                </div>
                                <div className="modal-body text-center">
                                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                                    <i className="ti ti-trash fs-40 text-danger" />
                                  </div>

                                  <h4 className="fw-bold text-dark mb-3">
                                    Delete {selectedContacts.length} Contact
                                    {selectedContacts.length > 1 ? "s" : ""}?
                                  </h4>

                                  <p className="text-muted fs-15 mb-4 px-4">
                                    This action <strong>cannot be undone</strong>.
                                    The selected contacts will be
                                    <strong> permanently removed</strong> from
                                    your system.
                                  </p>

                                  <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                                    <i className="ti ti-info-circle me-2" />
                                    <strong>Warning:</strong> This may affect
                                    related records, notes, call history, and
                                    email marketing data.
                                  </div>

                                  <div className="d-flex gap-3 justify-content-center mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-light px-5 py-2 fw-medium"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger px-5 py-2 fw-medium"
                                      onClick={async () => {
                                        await handleBulkDelete();
                                      }}
                                      data-bs-dismiss="modal"
                                      disabled={isSubmitting}
                                    >
                                      {isSubmitting ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          />
                                          Deleting...
                                        </>
                                      ) : (
                                        <>
                                          <i className="ti ti-trash me-2" />
                                          Yes, Delete Permanently
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <SequentialHighlight>
                            <button
                              className="btn btn-outline-warning me-2 mb-0"
                              onClick={() => setShowImportModal(true)}
                            >
                              <i className="ti ti-file-import me-2" />
                              Import Excel
                            </button>

                            <Link
                              to={route.contactimport}
                              className="btn btn-outline-success me-2 mb-0"
                            >
                              <i className="ti ti-address-book me-2" />
                              Import Contacts
                            </Link>
                            {userRole === "admin" && (
                              <Link
                                to={route.contactInsights}
                                className="btn btn-outline-info me-2 mb-0"
                              >
                                <i className="ti ti-graph me-2" />
                                Contacts Insights
                              </Link>
                            )}
                          </SequentialHighlight>

                          <div className="dropdown me-2">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary d-flex align-items-center gap-2 dropdown-toggle ${selectedContacts.length > 0
                                ? "border-primary text-primary"
                                : ""
                                }`}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              disabled={loading}
                            >
                              <i className="ti ti-package-export fs-16" />
                              <span className="d-none d-sm-inline">Export</span>
                              {selectedContacts.length > 0 && (
                                <span className="badge bg-primary rounded-pill ms-2">
                                  {selectedContacts.length}
                                </span>
                              )}
                            </button>

                            <ul
                              className="dropdown-menu dropdown-menu-end shadow-lg border-0 py-3 px-2"
                              style={{ minWidth: "260px" }}
                            >
                              {/* Header */}
                              <li>
                                <div className="px-3 mb-2">
                                  <small className="text-uppercase text-muted fw-bold">
                                    Export Options
                                  </small>
                                </div>
                              </li>

                              {/* Export All */}
                              <li>
                                <hr className="dropdown-divider my-1" />
                              </li>
                              <li>
                                <div className="px-3 py-1">
                                  <small className="text-muted">
                                    All Records ({contacts.length}){" "}
                                    {/* or filteredContacts.length if you have filtering */}
                                  </small>
                                </div>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                  onClick={handleExportAllPDF}
                                >
                                  <div className="avatar avatar-sm bg-danger-light rounded">
                                    <i className="ti ti-file-type-pdf text-danger fs-14" />
                                  </div>
                                  <div className="text-start">
                                    <div className="fw-medium">Export as PDF</div>
                                    <small className="text-muted">
                                      Portable Document Format
                                    </small>
                                  </div>
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                  onClick={handleExportAllExcel}
                                >
                                  <div className="avatar avatar-sm bg-success-light rounded">
                                    <i className="ti ti-file-spreadsheet text-success fs-14" />
                                  </div>
                                  <div className="text-start">
                                    <div className="fw-medium">
                                      Export as Excel
                                    </div>
                                    <small className="text-muted">
                                      Spreadsheet (.xlsx)
                                    </small>
                                  </div>
                                </button>
                              </li>

                              {/* Export Selected */}
                              {selectedContacts.length > 0 && (
                                <>
                                  <li>
                                    <hr className="dropdown-divider my-2" />
                                  </li>
                                  <li>
                                    <div className="px-3 py-1">
                                      <small className="text-muted">
                                        Selected Only ({selectedContacts.length})
                                      </small>
                                    </div>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                      onClick={() =>
                                        handleExportSelectedPDF(selectedContacts)
                                      }
                                    >
                                      <div className="avatar avatar-sm bg-danger-light rounded">
                                        <i className="ti ti-file-type-pdf text-danger fs-14" />
                                      </div>
                                      <div className="text-start">
                                        <div className="fw-medium">
                                          Export Selected as PDF
                                        </div>
                                      </div>
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                      onClick={() =>
                                        handleExportSelectedExcel(
                                          selectedContacts
                                        )
                                      }
                                    >
                                      <div className="avatar avatar-sm bg-success-light rounded">
                                        <i className="ti ti-file-spreadsheet text-success fs-14" />
                                      </div>
                                      <div className="text-start">
                                        <div className="fw-medium">
                                          Export Selected as Excel
                                        </div>
                                      </div>
                                    </button>
                                  </li>
                                </>
                              )}
                              {/* Customized Export */}
                              <li>
                                <hr className="dropdown-divider my-2" />
                              </li>
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                  onClick={() => {
                                    if (selectedContacts.length === 0) {
                                      toast.warning(
                                        "Please select at least one contact for customized export."
                                      );
                                      return;
                                    }
                                    setShowCustomExportModal(true);
                                  }}
                                >
                                  <div className="avatar avatar-sm bg-warning-light rounded">
                                    <i className="ti ti-file-settings text-warning fs-14" />
                                  </div>
                                  <div className="text-start">
                                    <div className="fw-medium">
                                      Customized Export
                                    </div>
                                    <small className="text-muted">
                                      Select columns & format
                                    </small>
                                  </div>
                                </button>
                              </li>
                              {/* No selection hint */}
                              {selectedContacts.length === 0 && (
                                <li>
                                  <div className="text-center py-3 px-3">
                                    <i className="ti ti-checkbox fs-32 text-muted d-block mb-2" />
                                    <small className="text-muted">
                                      Select rows to export specific records
                                    </small>
                                  </div>
                                </li>
                              )}
                            </ul>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary me-3"
                            
                            style={{
                              position: "relative",
                              overflow: "hidden",
                            }}
                            
                            
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvas_add"

                          >
                            <i
                              className="ti ti-square-rounded-plus me-2"
                              style={{ position: "relative", zIndex: 2 }}
                            />
                            <span style={{ position: "relative", zIndex: 2 }}>
                              Add Contacts
                            </span>
                            <span
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background:
                                  "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                                transform: "skewX(-20deg) translateX(-150%)",
                                animation: "shine 3s infinite",
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2 ">
                          <Link
                            to="#"
                            className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle text-primary d-inline-flex align-items-center"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Sort
                          </Link>
                          <div
                            className="dropdown-menu dropdown-menu-start"
                            style={{
                              minWidth: "240px",
                              maxWidth: "300px",
                              whiteSpace: "normal",
                            }}
                          >
                            <ul>
                              {[
                                { label: "Ascending", value: "ascending" },
                                { label: "Descending", value: "descending" },
                                // {
                                //   label: "Recently Viewed",
                                //   value: "recently_viewed",
                                // },
                                {
                                  label: "Recently Added",
                                  value: "recently_added",
                                },
                              ].map(({ label, value }) => {
                                const isActive = sortOption === value;
                                return (
                                  <li key={value}>
                                    <Link
                                      to="#"
                                      className={`dropdown-item d-flex justify-content-between align-items-center ${isActive ? "fw-bold text-primary" : ""
                                        }`}
                                      style={{
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                      }}
                                      onClick={() => setSortOption(value)}
                                    >
                                      <span>
                                        <i className="ti ti-circle-chevron-right me-1" />
                                        {label}
                                      </span>
                                      <div className="d-flex align-items-center mt-1 mt-sm-0">
                                        {isActive && (
                                          <i className="ti ti-check" />
                                        )}
                                      </div>
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>

                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-calendar" />
                          </span>
                          <DateRangePicker
                            initialSettings={initialSettings}
                            onCallback={(start, end, label) => {
                              setSelectedDateRange([
                                start.toDate(),
                                end.toDate(),
                              ]);
                              if (label) setActiveRangeLabel(label);
                            }}
                          >
                            <input
                              className="form-control bookingrange"
                              type="text"
                              readOnly
                            />
                          </DateRangePicker>
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <div className="dropdown ms-3">
                            <Link
                              to="#"
                              className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="ti ti-user-check me-2" />
                              Assignment
                              {/* Optional: show current selection count in button */}
                              {assignmentFilter !== "all" && (
                                <span className="badge bg-light text-dark ms-2">
                                  {
                                    assignmentCounts[
                                    assignmentFilter as keyof typeof assignmentCounts
                                    ]
                                  }
                                </span>
                              )}
                            </Link>

                            <div
                              className="dropdown-menu dropdown-menu-end p-3"
                              style={{ minWidth: "220px" }}
                            >
                              <ul className="list-unstyled mb-0">
                                {[
                                  {
                                    label: "All",
                                    value: "all",
                                    icon: "ti-list-details",
                                    iconClass: "",
                                  },
                                  {
                                    label: "Assigned",
                                    value: "assigned",
                                    icon: "ti-user-check",
                                    iconClass: "text-success",
                                  },
                                  {
                                    label: "Unassigned",
                                    value: "unassigned",
                                    icon: "ti-user-exclamation",
                                    iconClass: "text-danger",
                                  },
                                ].map(({ label, value, icon, iconClass }) => {
                                  const isActive = assignmentFilter === value;
                                  const count =
                                    assignmentCounts[
                                    value as keyof typeof assignmentCounts
                                    ];

                                  return (
                                    <li key={value}>
                                      <Link
                                        to="#"
                                        className={`dropdown-item status-dropdown-item rounded d-flex justify-content-between align-items-center px-3 py-2 ${isActive
                                          ? "active fw-semibold"
                                          : "text-dark hover-bg-light"
                                          }`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setAssignmentFilter(value);
                                        }}
                                      >
                                        <span className="d-flex align-items-center">
                                          <i
                                            className={`ti ${icon} me-3 fs-16 ${iconClass}`}
                                          />
                                          <span>{label}</span>
                                        </span>

                                        <span className="d-flex align-items-center gap-2">
                                          <span
                                            className={`badge rounded-pill px-2 py-1 fw-medium text-xs ${isActive
                                              ? "bg-white text-dark" // Changed text-primary to text-dark for contrast on active bg
                                              : value === "all"
                                                ? "bg-secondary text-white"
                                                : value === "active"
                                                  ? "bg-success text-white"
                                                  : "bg-danger text-white"
                                              }`}>
                                            {count.toLocaleString()}
                                          </span>
                                          {isActive && (
                                            <i className="ti ti-check text-primary" />
                                          )}
                                        </span>
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        {/* ✅ Add Assign To Button */}
                        {selectedContacts.length > 0 && (
                          <button
                            type="button"
                            className="btn btn-outline-secondary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#bulk_assign_modal"
                            onClick={handleOpenBulkAssignModal}
                            disabled={selectedContacts.length === 0}
                          >
                            <i className="ti ti-users me-2" />
                            Bulk Assign ({selectedContacts.length})
                          </button>
                        )}

                        {selectedContacts.length > 0 && (
  <button
    type="button"
    className="btn btn-outline-dark ms-2 me-2"
    onClick={handleOpenConvertModal}           // ← this is correct
  >
    <i className="ti ti-exchange fs-16"></i>
    Convert to Lead ({selectedContacts.length})
  </button>
)}

                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Permanently delete selected contacts"
                        >
                          {selectedContacts.length > 0 && (
                            <button
                              type="button"
                              className="btn btn-danger px-4 py-2 fw-medium d-flex align-items-center gap-2 shadow-sm me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#bulk_delete_contacts"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (selectedContacts.length === 0) {
                                  toast.warning(
                                    "No contacts selected for deletion"
                                  );
                                }
                              }}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  Deleting...
                                </>
                              ) : (
                                <>
                                  <i className="ti ti-trash fs-16" />
                                  Delete Selected ({selectedContacts.length})
                                </>
                              )}
                            </button>
                          )}
                        </span>

                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="btn bg-soft-purple text-purple"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-columns-3 me-2" />
                            Manage Columns
                          </Link>

                          <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                            <h4 className="mb-2 fw-semibold">
                              Want to manage datatables?
                            </h4>
                            <p className="mb-3">
                              Please drag and drop your column to reorder your
                              table and enable see option as you want.
                            </p>

                            <div className="border-top pt-3">
                              {/* {[
                                { key: "name", label: "Name" },
                                { key: "phone", label: "Phone" },
                                { key: "email", label: "Email" },
                                { key: "username", label: "Assign To" },
                                { key: "leadsource_name", label: "Lead Source" },
                                { key: "description", label: "Remarks" },
                                { key: "website", label: "Website URL" },
                                { key: "fax", label: "Fax" },
                                { key: "no_of_employee", label: "Employees" },
                                { key: "rating", label: "Rating" },
                                { key: "linkedin_url", label: "LinkedIn" },
                                { key: "call_date1", label: "Call Date 1" },
                                { key: "disposition1", label: "Disposition 1" },
                                { key: "call_date2", label: "Call Date 2" },
                                { key: "disposition2", label: "Disposition 2" },
                                {
                                  key: "email_marketing_date1",
                                  label: "Email Marketing Date 1",
                                },
                                { key: "email_status1", label: "Email Status 1" },
                                {
                                  key: "email_marketing_date2",
                                  label: "Email Marketing Date 2",
                                },
                                { key: "email_status2", label: "Email Status 2" },
                                { key: "meta_page", label: "Meta Page" },
                                { key: "designation", label: "Designation" },
                                // { key: "contact_notes", label: "Contact Notes" },
                                { key: "actions", label: "Action" },
                              ].map(({ key, label }) => (
                                <div
                                  key={key}
                                  className="d-flex align-items-center justify-content-between mb-3"
                                >
                                  <p className="mb-0 d-flex align-items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    {label}
                                  </p>
                                  <div className="status-toggle">
                                    <input
                                      type="checkbox"
                                      className="check"
                                      id={`col-${key}`}
                                      checked={visibleColumns[key]}
                                      onChange={() => handleColumnToggle(key)}
                                    />
                                    <label
                                      htmlFor={`col-${key}`}
                                      className="checktoggle"
                                    />
                                  </div>
                                </div>
                              ))} */}

                              <ColumnManagement
                                columnKeys={columnKeys}
                                visibleColumns={visibleColumns}
                                onColumnOrderChange={setColumnKeys}
                                onColumnToggle={handleColumnToggle}
                                fixedKeys={["actions"]}
                                labels={columnLabels}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-sorts dropdown me-4">
                          <Link
                            to="#"
                            className="dropdown-toggle dropdown-active-toggle common-filter-btn d-flex align-items-center gap-2 fw-medium"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-filter-share" /> Filter
                            {(filterNames.length > 0 ||
                              
                              filterPhones.length > 0 ||
                              filterLeadSources.length > 0 ||
                              filterOwners.length > 0 ||
                              filterCompanies.length > 0 ||
                              filterDesignations.length > 0 ||
                              filterEmails.length > 0) && (
                                <span className="badge bg-danger rounded-circle d-flex align-items-center justify-content-center text-white p-0">
                                  {filterNames.length +
                                    
                                    filterPhones.length +
                                    filterLeadSources.length +
                                    filterOwners.length +
                                    filterCompanies.length +
                                    filterDesignations.length +
                                    filterEmails.length}
                                </span>
                              )}
                          </Link>

                          <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                            <div className="filter-set-view">
                              <div className="filter-set-head">
                                <h4>
                                  <i className="ti ti-filter-share" /> Filter
                                </h4>
                              </div>

                              <div className="accordion" id="accordionExample">
                                {/* 🔹 Name Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={`filter-accordion-link ${openAccordion === "name"
                                        ? ""
                                        : "collapsed"
                                        }`}
                                      onClick={() => handleAccordionToggle("name")}
                                    >
                                      Name
                                    </Link>
                                    {filterNames.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterNames.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "name" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Names"
                                            value={filterNamesSearch}
                                            onChange={(e) =>
                                              setFilterNamesSearch(e.target.value)
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueNames
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  filterNamesSearch.toLowerCase()
                                                )
                                            )
                                            .map((name) => (
                                              <li key={name}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterNames.includes(
                                                        name
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          name,
                                                          filterNames,
                                                          setFilterNames
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {name}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueNames.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                filterNamesSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Phone Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={`filter-accordion-link ${openAccordion === "phone"
                                        ? ""
                                        : "collapsed"
                                        }`}
                                      onClick={() =>
                                        handleAccordionToggle("phone")
                                      }
                                    >
                                      Phone
                                    </Link>
                                    {filterPhones.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterPhones.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "phone" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Phones"
                                            value={filterPhonesSearch}
                                            onChange={(e) =>
                                              setFilterPhonesSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniquePhones
                                            .filter((p) =>
                                              p
                                                .toLowerCase()
                                                .includes(
                                                  filterPhonesSearch.toLowerCase()
                                                )
                                            )
                                            .map((phone) => (
                                              <li key={phone}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterPhones.includes(
                                                        phone
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          phone,
                                                          filterPhones,
                                                          setFilterPhones
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {phone}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniquePhones.filter((p) =>
                                            p
                                              .toLowerCase()
                                              .includes(
                                                filterPhonesSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Email Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={`filter-accordion-link ${openAccordion === "email"
                                        ? ""
                                        : "collapsed"
                                        }`}
                                      onClick={() =>
                                        handleAccordionToggle("email")
                                      }
                                    >
                                      Email
                                    </Link>
                                    {filterEmails.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterEmails.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "email" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Emails"
                                            value={filterEmailsSearch}
                                            onChange={(e) =>
                                              setFilterEmailsSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueEmails
                                            .filter((e) =>
                                              e
                                                .toLowerCase()
                                                .includes(
                                                  filterEmailsSearch.toLowerCase()
                                                )
                                            )
                                            .map((email) => (
                                              <li key={email}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterEmails.includes(
                                                        email
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          email,
                                                          filterEmails,
                                                          setFilterEmails
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {email}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueEmails.filter((e) =>
                                            e
                                              .toLowerCase()
                                              .includes(
                                                filterEmailsSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Designation Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={
                                        openAccordion === "designation"
                                          ? ""
                                          : "collapsed"
                                      }
                                      onClick={() =>
                                        handleAccordionToggle("designation")
                                      }
                                    >
                                      Designation
                                    </Link>
                                    {filterDesignations.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterDesignations.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "designation" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Designations"
                                            value={filterDesignationsSearch}
                                            onChange={(e) =>
                                              setFilterDesignationsSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueDesignations
                                            .filter((d) =>
                                              d
                                                .toLowerCase()
                                                .includes(
                                                  filterDesignationsSearch.toLowerCase()
                                                )
                                            )
                                            .map((desig) => (
                                              <li key={desig}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterDesignations.includes(
                                                        desig
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          desig,
                                                          filterDesignations,
                                                          setFilterDesignations
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {desig}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueDesignations.filter((d) =>
                                            d
                                              .toLowerCase()
                                              .includes(
                                                filterDesignationsSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Company Name Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={
                                        openAccordion === "company"
                                          ? ""
                                          : "collapsed"
                                      }
                                      onClick={() =>
                                        handleAccordionToggle("company")
                                      }
                                    >
                                      Company Name
                                    </Link>
                                    {filterCompanies.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterCompanies.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "company" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Company Names"
                                            value={filterCompaniesSearch}
                                            onChange={(e) =>
                                              setFilterCompaniesSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueCompanies
                                            .filter((c) =>
                                              c
                                                .toLowerCase()
                                                .includes(
                                                  filterCompaniesSearch.toLowerCase()
                                                )
                                            )
                                            .map((comp) => (
                                              <li key={comp}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterCompanies.includes(
                                                        comp
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          comp,
                                                          filterCompanies,
                                                          setFilterCompanies
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {comp}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueCompanies.filter((c) =>
                                            c
                                              .toLowerCase()
                                              .includes(
                                                filterCompaniesSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Lead Owner Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={
                                        openAccordion === "owner"
                                          ? ""
                                          : "collapsed"
                                      }
                                      onClick={() =>
                                        handleAccordionToggle("owner")
                                      }
                                    >
                                      Lead Owner
                                    </Link>
                                    {filterOwners.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterOwners.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "owner" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Owners"
                                            value={filterOwnersSearch}
                                            onChange={(e) =>
                                              setFilterOwnersSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueOwners
                                            .filter((o) =>
                                              o
                                                .toLowerCase()
                                                .includes(
                                                  filterOwnersSearch.toLowerCase()
                                                )
                                            )
                                            .map((owner) => (
                                              <li key={owner}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterOwners.includes(
                                                        owner
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          owner,
                                                          filterOwners,
                                                          setFilterOwners
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {owner}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueOwners.filter((o) =>
                                            o
                                              .toLowerCase()
                                              .includes(
                                                filterOwnersSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <hr className="my-2" />

                                {/* 🔹 Lead Source Filter */}
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      className={
                                        openAccordion === "source"
                                          ? ""
                                          : "collapsed"
                                      }
                                      onClick={() =>
                                        handleAccordionToggle("source")
                                      }
                                    >
                                      Lead Source
                                    </Link>
                                    {filterLeadSources.length > 0 && (
                                      <span className="badge bg-primary rounded-pill small">
                                        {filterLeadSources.length}
                                      </span>
                                    )}
                                  </div>
                                  {openAccordion === "source" && (
                                    <div className="filter-set-contents accordion-collapse collapse show">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Sources"
                                            value={filterLeadSourcesSearch}
                                            onChange={(e) =>
                                              setFilterLeadSourcesSearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>

                                        <ul className="list-unstyled mb-0">
                                          {uniqueLeadSources
                                            .filter((s) =>
                                              s
                                                .toLowerCase()
                                                .includes(
                                                  filterLeadSourcesSearch.toLowerCase()
                                                )
                                            )
                                            .map((source) => (
                                              <li key={source}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterLeadSources.includes(
                                                        source
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          source,
                                                          filterLeadSources,
                                                          setFilterLeadSources
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {source}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          {uniqueLeadSources.filter((s) =>
                                            s
                                              .toLowerCase()
                                              .includes(
                                                filterLeadSourcesSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                              <p className="text-muted px-2">
                                                No data found
                                              </p>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                  <hr className="my-2" />

                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className={
                                        openAccordion === "givenby"
                                          ? ""
                                          : "collapsed"
                                      }
                                      onClick={() =>
                                        handleAccordionToggle("givenby")
                                      }
                                    >
                                      Lead Given By
                                    </Link>
                                  </div>
                                  {openAccordion === "givenby" && (
                                    <div className="filter-set-contents accordion-collapse">
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Sources"
                                            value={filterLeadGivenBySearch}
                                            onChange={(e) =>
                                              setFilterLeadGivenBySearch(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        {uniqueLeadGivenBy
                                          .filter((s) =>
                                            s
                                              .toLowerCase()
                                              .includes(
                                                filterLeadGivenBySearch.toLowerCase()
                                              )
                                          )
                                          .map((givenby) => (
                                            <li key={givenby}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterLeadGivenBy.includes(
                                                      givenby
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        givenby,
                                                        filterLeadGivenBy,
                                                        setFilterLeadGivenBy
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {givenby}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {uniqueLeadGivenBy.filter((s) =>
                                          s
                                            .toLowerCase()
                                            .includes(
                                              filterLeadGivenBySearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Reset / Apply Buttons */}
                              <div className="filter-reset-btns mt-3">
                                <div className="row">
                                  <div className="col-6">
                                    <Link
                                      to="#"
                                      className="btn btn-light w-100"
                                      onClick={resetFilters}
                                    >
                                      Reset
                                    </Link>
                                  </div>
                                  <div className="col-6">
                                    <Link
                                      to="#"
                                      className="btn btn-primary w-100"
                                      data-bs-dismiss="dropdown"
                                    >
                                      Apply
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="view-icons">
                          <Link to="#" className="active">
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link to={route.contactGrid}>
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Filter
  contacts,
      debouncedSearchQuery,
      filterNames, // New deps
      filterCompanies,
      filterDesignations,
      filterOwners,
      filterLeadSources,
      filterPhones, // Existing
      filterEmails,
      assignmentFilter,
      sortOption,
      selectedDateRange,
      selectedStatuses,
      selectedCountries, Sidebar*/}
                    {/* Active Filters – Beautiful Removable Badges */}
                    {
                      (filterNames.length > 0 ||
                        filterCompanies.length > 0 ||
                        filterDesignations.length > 0 ||
                        filterOwners.length > 0 ||
                        filterLeadSources.length > 0 ||
    filterLeadGivenBy.length > 0 ||
                        filterPhones.length > 0 ||
                        filterEmails.length > 0 ||
                        selectedCountries.length > 0 ||
                        selectedStatuses.length > 0 ||
                        debouncedSearchQuery.length > 0 ||
                        assignmentFilter !== "all" ||
                        sortOption !== "recently_added" ||
                        selectedDateRange) && (
                        <div className="active-filters d-flex flex-wrap gap-2 mb-4 align-items-center">
                          {/* Search */}
                          {debouncedSearchQuery.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Search: {debouncedSearchQuery}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setSearchQuery("")} // or your actual setter
                              />
                            </span>
                          )}

                          {/* Names */}
                          {filterNames.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Name: {filterNames.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterNames([])}
                              />
                            </span>
                          )}

                          {/* Companies */}
                          {filterCompanies.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Company: {filterCompanies.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterCompanies([])}
                              />
                            </span>
                          )}

                          {/* Designations */}
                          {filterDesignations.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Designation: {filterDesignations.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterDesignations([])}
                              />
                            </span>
                          )}

                          {/* Owners */}
                          {filterOwners.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Owner: {filterOwners.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterOwners([])}
                              />
                            </span>
                          )}

                          {/* Lead Sources */}
                          {filterLeadSources.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Source: {filterLeadSources.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterLeadSources([])}
                              />
                            </span>
                          )}

                          {/* Phone & Email */}
                          {filterPhones.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Phone: {filterPhones.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterPhones([])}
                              />
                            </span>
                          )}
                          {filterEmails.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Email: {filterEmails.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setFilterEmails([])}
                              />
                            </span>
                          )}

                          {/* Country */}
                          {selectedCountries.length > 0 && (
                            <span className="alert alert-primary py-2 mb-2">
                              Country: {selectedCountries.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setSelectedCountries([])}
                              />
                            </span>
                          )}

                          {/* Status */}
                          {selectedStatuses.length > 0 && (
                            <span className="alert alert-success py-2 mb-2">
                              Status: {selectedStatuses.join(", ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setSelectedStatuses([])}
                              />
                            </span>
                          )}

                          {/* Date Range */}
                          {selectedDateRange && (
                            <span className="alert alert-primary py-2 mb-2">
                              {selectedDateRange[0].toLocaleDateString("en-GB")} –{" "}
                              {selectedDateRange[1].toLocaleDateString("en-GB")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setSelectedDateRange(null)}
                              />
                            </span>
                          )}

                          {/* Assignment */}
                          {assignmentFilter !== "all" && (
                            <span className="alert alert-primary py-2 mb-2">
                              Assignment: {assignmentFilter.replace(/_/g, " ")}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setAssignmentFilter("all")}
                              />
                            </span>
                          )}

                          {/* Sort */}
                          {sortOption !== "recently_added" && (
                            <span className="alert alert-primary py-2 mb-2">
                              Sort:{" "}
                              {sortOption
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())}
                              <i
                                className="ti ti-x fs-12 cursor-pointer ms-2"
                                onClick={() => setSortOption("recently_added")}
                              />
                            </span>
                          )}

                          {/* Clear All Button */}
                          {/* <button
        className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
        onClick={() => {
          setFilterNames([]);
          setFilterCompanies([]);
          setFilterDesignations([]);
          setFilterOwners([]);
          setFilterLeadSources([]);
          setFilterPhones([]);
          setFilterEmails([]);
          setSelectedCountries([]);
          setSelectedStatuses([]);
          setSelectedDateRange(null);
          setSearchQuery("");
          setAssignmentFilter("all");
          setSortOption("recently_added");
        }}
      >
        <i className="ti ti-filter-off" /> 
        Clear All
      </button> */}
                        </div>
                      )
                    }

                    <div className="table-responsive custom-table">
                      <Table
                        dataSource={filteredAndSortedContacts}
                        columns={allColumns}
                        rowKey="contact_id"
                        className="custom-table"
                        emptyText="No Contacts found"
                        emptyIcon="ti ti-user-off"
                        enableRowSelection={true}
                        //locale={{ emptyText: "No contacts available" }}
                        loading={loading}
                        scroll={{ x: "max-content" }}
                        pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          showSizeChanger: true,

                          pageSizeOptions: ["10", "20", "50", "75", "100"],
                          onChange: (page: number, size: number) => {
                            setCurrentPage(page);
                            setPageSize(size);
                          },
                        }}
                        recordLabel="Contacts"
                        draggable={true} // <-- ENABLE
                        enableColumnDrag={true}
                        onRowOrderChange={handleRowOrderChange} // <-- callback
                        onColumnOrderChange={(newCols: any[]) => {
                          console.log(
                            "🔄 onColumnOrderChange called with",
                            newCols.length,
                            "columns"
                          );

                          // Get the new order of non-sticky columns from the dragged columns
                          const newOrderedKeys = newCols
                            .filter((c) => !c.fixed) // Only non-sticky columns
                            .map((c) => c.key || c.dataIndex)
                            .filter(
                              (key) =>
                                key !== undefined && key !== null && key !== ""
                            ); // Remove invalid keys

                          console.log(
                            "📋 New ordered keys (non-sticky):",
                            newOrderedKeys
                          );
                          console.log("📋 Current columnKeys:", columnKeys);
                          console.log("📋 Default order:", defaultColumnOrder);

                          // Preserve columns that are not in newCols (hidden columns) by merging with existing columnKeys
                          const existingKeys = columnKeys;
                          const allNonStickyKeys = defaultColumnOrder; // All possible non-sticky column keys

                          // Create a new array that:
                          // 1. Uses the new order for visible columns
                          // 2. Preserves the order of hidden columns that aren't in newCols
                          const preservedKeys = existingKeys.filter(
                            (key) => !newOrderedKeys.includes(key)
                          );
                          const finalKeys = [...newOrderedKeys, ...preservedKeys];

                          // Ensure all default columns are included (in case some are missing)
                          const missingKeys = allNonStickyKeys.filter(
                            (key) => !finalKeys.includes(key)
                          );
                          const completeKeys = [...finalKeys, ...missingKeys];

                          console.log("💾 Setting columnKeys to:", completeKeys);
                          setColumnKeys(completeKeys);
                          // Don't auto-save, let user decide on navigation/refresh
                        }}
                        rowSelection={{
                          selectedRowKeys: selectedContacts,
                          onChange: (keys: React.Key[]) =>
                            setSelectedContacts(keys.map(String)),
                          columnWidth: 50,
                          fixed: true,
                        }}
                        expandable={{
                          expandedRowRender: (record) => {
                            const hasBranches =
                              Array.isArray(record.branches) &&
                              record.branches.length > 0;
                            return hasBranches ? (
                              <div className="p-3 bg-light rounded shadow-sm">
                                <h6 className="mb-3 text-primary fw-bold">
                                  <i className="ti ti-map-pin me-2"></i>Branch Details
                                </h6>
                                <div className="table-responsive">
                                  <table className="table table-bordered table-hover bg-white m-0">
                                    <thead className="table-light">
                                      <tr>
                                        <th>Branch</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Country</th>
                                        <th>Zipcode</th>
                                        <th>GST Number</th>
                                        <th>Address</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {record.branches!.map((b: Branch, i: number) => (
                                        <tr key={i}>
                                          <td className="fw-medium text-dark">{b.branch_name || "N/A"}</td>
                                          <td>{b.branch_city || "N/A"}</td>
                                          <td>{b.branch_state || "N/A"}</td>
                                          <td>{b.branch_country || "N/A"}</td>
                                          <td>{b.branch_zipcode || "N/A"}</td>
                                          <td>
                                            <span className="badge bg-info-light text-info border border-info-light">
                                              {b.gst_number || "N/A"}
                                            </span>
                                          </td>
                                          <td>
                                            <small className="text-muted">{b.branch_address || "N/A"}</small>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            ) : null;
                          },
                          rowExpandable: () => true,
                          expandIcon: ({ expanded, onExpand, record }) => {
                            const isExpandable =
                              Array.isArray(record.branches) &&
                              record.branches.length > 0;
                            const isFav = favorites.includes(record.contact_id);

                            return (
                              <div
                                className="d-flex align-items-center gap-2 pr-2"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {/* Expansion Trigger */}
                                {/* Expand / Collapse Icon */}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (isExpandable) onExpand(record, e);
                                  }}
                                  onPointerDown={(e) => e.stopPropagation()}
                                  className={`d-flex align-items-center justify-content-center ${isExpandable ? "cursor-pointer expand-icon-box" : "opacity-0"
                                    }`}
                                  style={{ width: 22, height: 22, cursor: isExpandable ? "pointer" : "default" }}
                                >
                                  {isExpandable &&
                                    (expanded ? (
                                      <MinusOutlined className="expand-icon" />
                                    ) : (
                                      <PlusOutlined className="expand-icon" />
                                    ))}
                                </div>

                                {/* Favorite Star */}
                                <div
                                  className="cursor-pointer d-flex align-items-center justify-content-center"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleFavorite(record.contact_id);
                                  }}
                                  onPointerDown={(e) => e.stopPropagation()}
                                  style={{ width: 22, height: 22, cursor: "pointer" }}
                                >
                                  {isFav ? (
                                    <StarFilled style={{ fontSize: 18, color: "#EAB308" }} />
                                  ) : (
                                    <StarOutlined style={{ fontSize: 18, color: "#9CA3AF" }} />
                                  )}
                                </div>

                              </div>
                            );
                          },
                          columnTitle: (
                            <div className="d-flex align-items-center justify-content-center w-100">
                              <Dropdown
                                trigger={["click"]}
                                overlay={
                                  <Menu
                                    selectedKeys={showOnlyFavorites ? ["fav"] : []}
                                    onClick={({ key }) => {
                                      if (key === "fav") {
                                        setShowOnlyFavorites(!showOnlyFavorites);
                                      }
                                    }}
                                    style={{ minWidth: 150 }}
                                  >
                                    <Menu.Item key="fav" className="d-flex align-items-center justify-content-between">
                                      <span>
                                        <StarFilled style={{ color: "#EAB308", marginRight: 8 }} />
                                        Favorites
                                      </span>
                                      <span className="badge bg-warning-light rounded-pill ms-3">
                                        {favoriteCount}
                                      </span>
                                    </Menu.Item>
                                    {showOnlyFavorites && (
                                      <Menu.Item key="clear" onClick={() => setShowOnlyFavorites(false)} className="text-muted small">
                                        <i className="ti ti-x me-2"></i>
                                        Clear Filter
                                      </Menu.Item>
                                    )}
                                  </Menu>
                                }
                              >
                                <Button
                                  size="sm"
                                  type="button"
                                  onClick={(e) => e.stopPropagation()}
                                  className="p-0 d-flex align-items-center justify-content-center"
                                  style={{ width: 32, height: 32 }}
                                >
                                  <FunnelPlotFilled
                                    style={{
                                      fontSize: 15,
                                      color: showOnlyFavorites ? "#EAB308" : "#666",
                                    }}
                                  />
                                  {showOnlyFavorites && (
                                    <span className="ms-1 small fw-semibold">
                                      {favoriteCount}
                                    </span>
                                  )}
                                </Button>
                              </Dropdown>
                            </div>
                          ),
                          columnWidth: 60,
                          fixed: "left",
                        }}
                      />
                    </div>

                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                  </div >
                </div >
              </div >
            </div >
          </div >
        </div >

            {/* Assign User Modal (Single Contact) */}
        {/* Assign User Modal - Enhanced & Consistent Style */}
        <div
          className="modal fade"
          id="assign_user_modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="assignUserLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title text-primary fw-bold"
                  id="assignUserLabel"
                >
                  <i className="ti ti-user-plus me-2" />
                  Assign User to Contact
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <div className="modal-body text-center py-4">
                <div className="avatar avatar-xl bg-primary-light rounded-circle mb-4 mx-auto">
                  <i className="ti ti-user-plus fs-40 text-primary" />
                </div>

                <h4 className="fw-bold text-dark mb-3">Assign Lead Owner</h4>

                <p className="text-muted fs-15 mb-4 px-4">
                  Select a user from your team to assign as the owner of this
                  contact.
                </p>

                {/* User Selection */}
                <div className="px-4">
                  {loadingUsers ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading users...</span>
                      </div>
                      <p className="mt-3 text-muted">
                        Loading available users...
                      </p>
                    </div>
                  ) : users.length === 0 ? (
                    <div className="alert alert-info py-3 mb-4">
                      <i className="ti ti-info-circle me-2" />
                      No users found for this client.
                    </div>
                  ) : (
                    <div className="mb-4">
                      <label className="form-label fw-medium text-start d-block">
                        Select User <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select form-select-lg"
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        disabled={loadingUsers}
                      >
                        <option value="">Choose a user...</option>
                        {users.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.name}{" "}
                            {user.email && (
                              <small className="text-muted">({user.email})</small>
                            )}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3 justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light px-5 py-2 fw-medium"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary px-5 py-2 fw-medium d-flex align-items-center gap-2"
                    onClick={handleAssignUser}
                    data-bs-dismiss="modal"
                    disabled={!selectedUserId || loadingUsers || isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Assigning...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-user-check me-2" />
                        Assign User
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Bulk Assign User Modal */}
        {/* Bulk Assign User Modal - Enhanced & Consistent */}
        <div
          className="modal fade"
          id="bulk_assign_modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="bulkAssignLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title text-primary fw-bold"
                  id="bulkAssignLabel"
                >
                  <i className="ti ti-users me-2" />
                  Bulk Assign Users
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <div className="modal-body text-center py-4">
                <div className="avatar avatar-xl bg-primary-light rounded-circle mb-4 mx-auto">
                  <i className="ti ti-users fs-40 text-primary" />
                </div>

                <h4 className="fw-bold text-dark mb-3">
                  Assign {selectedContacts.length} Contact
                  {selectedContacts.length > 1 ? "s" : ""}
                </h4>

                <p className="text-muted fs-15 mb-4 px-4">
                  All selected contacts will be assigned to the same user.
                </p>

                <div className="px-4">
                  {loadingUsers ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      ></div>
                      <p className="mt-3 text-muted">Loading users...</p>
                    </div>
                  ) : users.length === 0 ? (
                    <div className="alert alert-info py-3 mb-4">
                      <i className="ti ti-info-circle me-2" />
                      No users available for assignment.
                    </div>
                  ) : (
                    <div className="mb-4">
                      <label className="form-label fw-medium text-start d-block">
                        Assign To <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select form-select-lg"
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                      >
                        <option value="">Select a user...</option>
                        {users.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3 justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light px-5 py-2 fw-medium"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary px-5 py-2 fw-medium d-flex align-items-center gap-2"
                    onClick={handleBulkAssignUser}
                    data-bs-dismiss="modal"
                    disabled={
                      !selectedUserId ||
                      selectedContacts.length === 0 ||
                      isSubmitting
                    }
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                        Assigning...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-check me-2" />
                        Assign to All
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

          <Modal
    show={showBulkDeleteModal}
    onHide={() => setShowBulkDeleteModal(false)}
    centered
  >
    <div className="modal-header border-0 m-0 justify-content-end">
      <button
        className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
        aria-label="Close"
        onClick={() => setShowBulkDeleteModal(false)}
      >
        <i className="ti ti-x" />
      </button>
    </div>
    <div className="modal-body text-center p-4">
      <div className="success-popup-icon bg-light-danger mb-3">
        <i className="ti ti-trash fs-36 text-danger" />
      </div>
      <h4 style={{ color: "red" }}>Confirm Bulk Delete</h4>
      <p className="mb-3">
        Are you sure you want to delete{" "}
        <strong>{selectedContacts.length}</strong> selected contacts?
      </p>
      <div className="d-flex justify-content-center gap-3">
        <button
          className="btn btn-secondary"
          onClick={() => setShowBulkDeleteModal(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={async () => {
            await handleBulkDelete();
            setShowBulkDeleteModal(false);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </Modal>
    <Modal
          show={showCustomExportModal}
          onHide={() => setShowCustomExportModal(false)}
          centered
          dialogAs={(props) => (
            <div {...props} id="custom_export_modal" />
          )}
          className="effect-modal-show"
        >
          <div
            id="custom_export_modal"
            className="modal fade show"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-primary fw-bold">
                    <i className="ti ti-file-export me-2" />
                    Customized Export
                  </h5>
                  <button
                    type="button"
                    className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                    onClick={() => setShowCustomExportModal(false)}
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>

                {selectedContacts.length === 0 && (
                  <div className="alert alert-warning py-2 mx-3 mt-3">
                    Please select at least one row from the table to export data.
                  </div>
                )}

                <div className="modal-body p-4">
                  <p className="text-muted mb-4">
                    Select columns to include in the export ({selectedContacts.length}{" "}
                    contacts selected):
                  </p>

                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="export-col-all"
                          checked={allColumnsSelected}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const updated = Object.keys(exportColumns).reduce(
                              (acc, key) => {
                                acc[key as keyof typeof exportColumns] = checked;
                                return acc;
                              },
                              {} as typeof exportColumns
                            );
                            setExportColumns(updated);
                          }}
                        />
                        <label
                          className="form-check-label fw-semibold"
                          htmlFor="export-col-all"
                        >
                          Select All Columns
                        </label>
                      </div>
                      <hr />
                    </div>

                    {Object.keys(exportColumns).map((key) => (
                      <div className="col-md-6 mb-2" key={key}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`export-col-${key}`}
                            checked={exportColumns[key as keyof typeof exportColumns]}
                            onChange={() =>
                              handleExportColumnToggle(
                                key as keyof typeof exportColumns
                              )
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`export-col-${key}`}
                          >
                            {key
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase())}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light px-4 py-2 fw-medium"
                    onClick={() => setShowCustomExportModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary px-4 py-2"
                    onClick={() => handleCustomExport("pdf")}
                    disabled={
                      selectedContacts.length === 0 || !hasSelectedExportColumn
                    }
                  >
                    Export as PDF
                  </button>
                  <button
                    className="btn btn-primary px-4 py-2"
                    onClick={() => handleCustomExport("excel")}
                    disabled={
                      selectedContacts.length === 0 || !hasSelectedExportColumn
                    }
                  >
                    Export as Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
          <div
            className="offcanvas offcanvas-end offcanvas-large"
            tabIndex={-1}
            id="offcanvas_add"
          >
            <div className="offcanvas-header border-bottom">
              <h5 className="fw-semibold">Add New Contact</h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="offcanvas-body">
              <form>
                <div className="accordion" id="main_accordion">
                  <div className="accordion-item rounded mb-3">
                    <div className="accordion-header">
                      <Link
                        to="#"
                        className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                        data-bs-toggle="collapse"
                        data-bs-target="#basic"
                      >
                        <span className="avatar avatar-md rounded text-dark border me-2">
                          <i className="ti ti-user-plus fs-20" />
                        </span>
                        Basic Info
                      </Link>
                    </div>
                    <div
                      className="accordion-collapse collapse show"
                      id="basic"
                      data-bs-parent="#main_accordion"
                    >
                      <div className="accordion-body border-top">
                        <h6 className="mt-3 mb-4 border-bottom pb-1">
                          <i className="ti ti-building me-2 text-primary" />
                          Company Info
                        </h6>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="contact-company-name"
                              >
                                Company Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="contact-company-name"
                                name="contact_Company_name"
                                className="form-control"
                                placeholder="e.g. Abc Pvt Ltd"
                                value={newContact.contact_Company_name}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="branch-type"
                              >
                                Branch Type <span className="text-danger">*</span>
                              </label>
                              <select
                                id="branch-type"
                                name="branch_type"
                                className="form-select"
                                value={addressMode}
                                onChange={(e) =>
                                  setAddressMode(
                                    e.target.value as "single" | "multiple"
                                  )
                                }
                              >
                                <option value="single">Single</option>
                                <option value="multiple">Multiple</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="contact-name"
                              >
                                Contact Person Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="contact-name"
                                name="contact_name"
                                className="form-control"
                                placeholder="e.g. John"
                                value={newContact.contact_name}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="contact-designation"
                              >
                                Company Designation
                              </label>
                              <input
                                type="text"
                                id="contact-designation"
                                name="contact_desigination"
                                className="form-control"
                                placeholder="e.g. IT Manager, Production Head"
                                value={newContact.contact_desigination}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="website-url"
                              >
                                Website
                              </label>
                              <input
                                type="text"
                                id="website-url"
                                name="website_url"
                                className="form-control"
                                placeholder="e.g. https://www.abc.com"
                                value={newContact.website_url}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="contact-phone"
                              >
                                Phone <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="contact-phone"
                                name="contact_phone"
                                className="form-control"
                                placeholder="e.g. +919876543210, 9876543210"
                                value={newContact.contact_phone}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          {/* Email */}
                          <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Email
                            </label>
                            <input
                              type="email"
                              name="contact_mail"
                              className="form-control"
                              placeholder="e.g. abc@gmail.com"
                              value={newContact.contact_mail}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                          {/* Lead From */}
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="lead-from"
                              >
                                Lead From <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ti ti-database" />
                                </span>
                                <select
                                  id="lead-from"
                                  name="lead_from"
                                  className="form-select"
                                  value={newContact.lead_from || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    -- Select Lead Source --
                                  </option>
                                  {leadSources.map((source) => (
                                    <option
                                      key={source.LeadSource_id}
                                      value={source.LeadSource_id}
                                    >
                                      {source.LeadSource_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="lead-givenby"
                              >
                                Lead Given By <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ti ti-user" />
                                </span>
                                <select
                                  id="lead-givenby"
                                  name="leadgivenby_id"
                                  className="form-select"
                                  value={newContact.leadgivenby_id || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">
                                    -- Select Lead Given By --
                                  </option>
                                  {leadGivenBys.map((giver) => (
                                    <option
                                      key={giver.leadgivenby_id}
                                      value={giver.leadgivenby_id}
                                    >
                                      {giver.LeadGivenBy_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-0">
                              <label
                                className="col-form-label"
                                htmlFor="contact-description"
                              >
                                Remarks
                              </label>
                              <textarea
                                id="contact-description"
                                name="contact_description"
                                className="form-control"
                                placeholder="Enter any additional information about the contact (optional)"
                                rows={4}
                                value={newContact.contact_description}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {addressMode === "multiple" && (
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={addNewAddress}
                      >
                        <i className="ti ti-plus me-1" /> Add Address
                      </button>
                    </div>
                  )}
                  <div className="accordion-item rounded mb-3">
                    <div className="accordion-header">
                      <Link
                        to="#"
                        className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark flex-grow-1"
                        data-bs-toggle="collapse"
                        data-bs-target="#address"
                      >
                        <span className="avatar avatar-md rounded text-dark border me-2">
                          <i className="ti ti-map-pin-cog fs-20" />
                        </span>
                        Address Info
                      </Link>
                    </div>
                    <div
                      className="accordion-collapse collapse"
                      id="address"
                      data-bs-parent="#main_accordion"
                    >
                      <div className="accordion-body border-top">
                        {addressMode === "single" ? (
                          <div className="row">
                            <h6 className="mt-3 mb-3 border-bottom pb-1">
                              <i className="ti ti-file-description me-2 text-primary" />
                              Additional Info
                            </h6>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Contact Person Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="contact_name"
                                  className="form-control"
                                  value={newContact.contact_name}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="contact-address"
                                >
                                  Branch
                                </label>
                                <input
                                  type="text"
                                  id="contact-address"
                                  name="contact_address"
                                  className="form-control"
                                  placeholder="e.g. Main Office, Branch 1"
                                  value={newContact.contact_address}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="contact-city"
                                >
                                  City <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  id="contact-city"
                                  name="contact_city"
                                  className="form-control"
                                  placeholder="e.g. Chennai"
                                  value={newContact.contact_city}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="contact-state"
                                >
                                  State
                                </label>
                                <input
                                  type="text"
                                  id="contact-state"
                                  name="contact_state"
                                  className="form-control"
                                  placeholder="e.g. Tamil Nadu"
                                  value={newContact.contact_state}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="contact-country"
                                >
                                  Country
                                </label>
                                <input
                                  type="text"
                                  id="contact-country"
                                  name="contact_country"
                                  className="form-control"
                                  placeholder="e.g. India"
                                  value={newContact.contact_country}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="contact-zipcode"
                                >
                                  Zipcode
                                </label>
                                <input
                                  type="text"
                                  id="contact-zipcode"
                                  name="contact_zipcode"
                                  className="form-control"
                                  placeholder="e.g. 600001"
                                  value={newContact.contact_zipcode}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="gst-number"
                                >
                                  GST Number
                                </label>
                                <input
                                  type="text"
                                  id="gst-number"
                                  name="gst_number"
                                  className="form-control"
                                  placeholder="e.g. 27AAAPL1234C1Z5"
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          addresses.map((addr, index) => (
                            <div className="border p-3 mb-3 rounded" key={index}>
                              <div className="row">
                                <div className="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                  <label className="col-form-label fw-semibold mb-0">
                                    Branch #{index + 1}
                                  </label>
                                  {addresses.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger"
                                      onClick={() => removeAddress(index)}
                                    >
                                      <i className="ti ti-trash" /> Remove
                                    </button>
                                  )}
                                </div>
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Contact Person Name{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="contact_name"
                                      className="form-control"
                                      value={newContact.contact_name}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Branch
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.contact_address}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "contact_address",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      City<span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.contact_city}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "contact_city",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      State
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.contact_state}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "contact_state",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.contact_country}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "contact_country",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Zipcode
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.contact_zipcode}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "contact_zipcode",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      GST Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={addr.gst_number}
                                      onChange={(e) =>
                                        updateAddressField(
                                          index,
                                          "gst_number",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    
    <div className="form-check">
      <Checkbox
        checked={assignOnCreate}
        onChange={(e) => {
          setAssignOnCreate(e.target.checked);
          if (!e.target.checked) {
            setSelectedUserForCreate("");
          }
        }}
      >
        Assign to User
      </Checkbox>
      
    </div>
     
    {assignOnCreate && (
     <div className="row mt-4">
       <div className="col-md-6">
  <div className="mb-3">
    {/* <label className="col-form-label" htmlFor="assign-user">
      Assign to User <span className="text-danger">*</span>
    </label> */}

    <div className="input-group">
      <span className="input-group-text">
        <i className="ti ti-user" />
      </span>

      <div className="flex-grow-1">
        <Select
          inputId="assign-user"
          options={users.map(user => ({
            value: String(user.id ?? ""),
            label: user.name,
          }))}

          value={
            users.find(u => u.id === selectedUserForCreate)
              ? {
                  value: selectedUserForCreate,
                  label: users.find(u => u.id === selectedUserForCreate)?.name,
                }
              : null
          }

          onChange={(option) =>
            setSelectedUserForCreate(option?.value || "")
          }

          placeholder="-- Select User --"
          isClearable

          //classNamePrefix="react-select"
          styles={{
            control: (base) => ({
              ...base,
              borderRadius: "0 0.375rem 0.375rem 0",
              borderLeft: "0",
              minHeight: "38px",
            }),
            valueContainer: (base) => ({
              ...base,
              padding: "0.375rem 0.75rem",
            }),
            indicatorsContainer: (base) => ({
              ...base,
              height: "38px",
            }),
          }}
        />
      </div>
    </div>
  </div>
</div>

       </div>
    )}
    
  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    data-bs-dismiss="offcanvas"
                    className="btn btn-light me-2"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            className={`offcanvas offcanvas-end offcanvas-large${
              showEditModal ? " show" : ""
            }`}
            tabIndex={-1}
            id="offcanvas_edit"
            style={{
              visibility: showEditModal ? "visible" : "hidden",
              pointerEvents: showEditModal ? "auto" : "none",
            }}
            aria-modal={showEditModal ? "true" : "false"}
            role="dialog"
          >
            <div className="offcanvas-header border-bottom">
              <h5 className="fw-semibold">Edit Contact</h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCloseEditModal}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="offcanvas-body">
              {editContact ? (
                <form>
                  <div className="accordion" id="main_accordion_2">
                    <div className="accordion-item rounded mb-3">
                      <div className="accordion-header">
                        <Link
                          to="#"
                          className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                          data-bs-toggle="collapse"
                          data-bs-target="#basic-2"
                        >
                          <span className="avatar avatar-md rounded text-dark border me-2">
                            <i className="ti ti-user-plus fs-20" />
                          </span>
                          Basic Info
                        </Link>
                      </div>
                      <div
                        className="accordion-collapse collapse show"
                        id="basic-2"
                        data-bs-parent="#main_accordion_2"
                      >
                        <div className="accordion-body border-top">
                          <h6 className="mt-3 mb-4 border-bottom pb-1">
                            <i className="ti ti-building me-2 text-primary" />
                            Company Info
                          </h6>
                          <div className="row">
                            {[
                              {
                                label: "Company Name",
                                key: "contact_Company_name",
                                required: true,
                              },
                              {
                                label: "Branch Type",
                                key: "address_mode",
                                isSelect: true,
                                options: ["single", "multiple"],
                                required: true,
                              },
                              {
                                label: "Contact Person Name",
                                key: "contact_name",
                                required: true,
                              },
                              {
                                label: "Designation",
                                key: "contact_desigination",
                              },
                              {
                                label: "Phone",
                                key: "contact_phone",
                                required: true,
                              },
                              {
                                label: "Email",
                                key: "contact_mail",
                                required: true,
                              },
                              { label: "Website", key: "website_url" },
                              {
                                label: "Lead From",
                                key: "lead_from",
                                isLeadDropdown: true,
                                required: true,
                              },
                              {
                                label: "Lead Given By",
                                key: "leadgivenby_id",
                                isLeadGivenByDropdown: true,
                                required: true,
                              },
                              {
                                label: "Remarks",
                                key: "contact_description",
                                isTextarea: true,
                              },
                            ].map((field) => (
                              <div
                                className={`col-md-${field.isTextarea ? 12 : 6}`}
                                key={field.key}
                              >
                                <div className="mb-3">
                                  <label className="col-form-label">
                                    {field.label}{" "}
                                    {field.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                  {field.isTextarea ? (
                                    <textarea
                                      className="form-control"
                                      rows={4}
                                      value={
                                        (editContact as any)[field.key] || ""
                                      }
                                      onChange={(e) =>
                                        setEditContact({
                                          ...editContact,
                                          [field.key]: e.target.value,
                                        })
                                      }
                                    />
                                  ) : field.isSelect ? (
                                    <select
                                      className="form-select"
                                      value={
                                        (editContact as any)[field.key] || ""
                                      }
                                      onChange={(e) =>
                                        setEditContact({
                                          ...editContact,
                                          [field.key]: e.target.value,
                                        })
                                      }
                                    >
                                      {field.options?.map((opt: string) => (
                                        <option key={opt} value={opt}>
                                          {opt.charAt(0).toUpperCase() +
                                            opt.slice(1)}
                                        </option>
                                      ))}
                                    </select>
                                  ) : field.isLeadDropdown ? (
                                    <div className="input-group">
                                      <span className="input-group-text">
                                        <i className="ti ti-database" />
                                      </span>
                                      <select
                                        className="form-select"
                                        value={
                                          (editContact as any)[field.key] || ""
                                        }
                                        onChange={(e) =>
                                          setEditContact({
                                            ...editContact,
                                            [field.key]: e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          -- Select Lead Source --
                                        </option>
                                        {leadSources.map((source) => (
                                          <option
                                            key={source.LeadSource_id}
                                            value={source.LeadSource_id}
                                          >
                                            {source.LeadSource_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  ) : field.isLeadGivenByDropdown ? (
                                    <div className="input-group">
                                      <span className="input-group-text">
                                        <i className="ti ti-user" />
                                      </span>
                                      <select
                                        className="form-select"
                                        value={
                                          (editContact as any)[field.key] || ""
                                        }
                                        onChange={(e) =>
                                          setEditContact({
                                            ...editContact,
                                            [field.key]: e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          -- Select Lead Given By --
                                        </option>
                                        {leadGivenBys.map((giver) => (
                                          <option
                                            key={giver.leadgivenby_id}
                                            value={giver.leadgivenby_id}
                                          >
                                            {giver.LeadGivenBy_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={
                                        (editContact as any)[field.key] || ""
                                      }
                                      onChange={(e) =>
                                        setEditContact({
                                          ...editContact,
                                          [field.key]: e.target.value,
                                        })
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {editContact?.address_mode === "multiple" && (
                      <>
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => {
                              const updated = [
                                ...(editContact.branches || []),
                                {
                                  branch_id: `temp-${Date.now()}`,
                                  branch_name: `Branch ${
                                    (editContact.branches?.length || 0) + 1
                                  }`,
                                  branch_address: "",
                                  branch_city: "",
                                  branch_state: "",
                                  branch_zipcode: "",
                                  branch_country: "",
                                  gst_number: "",
                                },
                              ];
                              setEditContact({
                                ...editContact,
                                branches: updated,
                              });
                            }}
                          >
                            <i className="ti ti-plus me-1" /> Add Address
                          </button>
                        </div>
                        <div className="accordion-item border-top rounded mb-3">
                          <div className="accordion-header">
                            <Link
                              to="#"
                              className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                              data-bs-toggle="collapse"
                              data-bs-target="#address-2"
                            >
                              <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-map-pin-cog fs-20" />
                              </span>
                              Address Info
                            </Link>
                          </div>
                          <div
                            className="accordion-collapse collapse show"
                            id="address-2"
                          >
                            <div className="accordion-body border-top">
                              {(editContact.branches || []).map(
                                (branch, index) => (
                                  <div
                                    className="border p-3 mb-3 rounded"
                                    key={branch.branch_id || index}
                                  >
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <strong>Branch #{index + 1}</strong>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => {
                                          const updated = [
                                            ...(editContact.branches || []),
                                          ];
                                          updated.splice(index, 1);
                                          setEditContact({
                                            ...editContact,
                                            branches: updated,
                                          });
                                        }}
                                      >
                                        <i className="ti ti-trash" /> Remove
                                      </button>
                                    </div>
                                    {renderBranchFields(branch, index)}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {editContact?.address_mode === "single" && (
                      <div className="accordion-item border-top rounded mb-3">
                        <div className="accordion-header">
                          <Link
                            to="#"
                            className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                            data-bs-toggle="collapse"
                            data-bs-target="#address-2"
                          >
                            <span className="avatar avatar-md rounded text-dark border me-2">
                              <i className="ti ti-map-pin-cog fs-20" />
                            </span>
                            Address Info
                          </Link>
                        </div>
                        <div
                          className="accordion-collapse collapse show"
                          id="address-2"
                        >
                          <div className="accordion-body border-top">
                            {renderBranchFields(
                              editContact.branches?.[0],
                              0,
                              true
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex align-items-center justify-content-end mt-3">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={handleCloseEditModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="offcanvas"
                      onClick={handleUpdateContact}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              ) : (
                <div className="text-muted text-center mt-4">
                  <i className="ti ti-alert-circle me-2" />
                  No contact selected.
                </div>
              )}
            </div>
          </div>
          {showEditModal && (
            <div
              className="offcanvas-backdrop fade show"
              onClick={handleCloseEditModal}
              style={{ cursor: "pointer" }}
            ></div>
          )}
          
          <div
          className="modal fade effect-modal-show"
          id="delete_contact"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="deleteContactLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title text-danger fw-bold"
                  id="deleteContactLabel"
                >
                  <i className="ti ti-alert-triangle me-2" />
                  Confirm Deletion
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto avatar avatar-xl effect-avatar-pulse">
                  <i className="ti ti-trash fs-40 text-danger" />
                </div>

                {/* Show contact name if available */}
                {contactToDelete &&
                  contacts.find((c) => c.contact_id === contactToDelete) && (
                    <h4 className="fw-bold text-dark mb-3">
                      Delete "
                      {contacts.find((c) => c.contact_id === contactToDelete)
                        ?.contact_Company_name ||
                        contacts.find((c) => c.contact_id === contactToDelete)
                          ?.contact_name}
                      "?
                    </h4>
                  )}

                {!contactToDelete && (
                  <h4 className="fw-bold text-dark mb-3">Delete This Contact?</h4>
                )}

                <p className="text-muted fs-15 mb-4 px-4">
                  This action <strong>cannot be undone</strong>. The contact will
                  be
                  <strong> permanently removed</strong> from your system.
                </p>

                <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                  <i className="ti ti-info-circle me-2" />
                  <strong>Warning:</strong> All associated data (notes, calls,
                  emails) will also be deleted.
                </div>

                <div className="d-flex gap-3 justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light px-5 py-2 fw-medium"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger px-5 py-2 fw-medium"
                    onClick={handleDeleteContact}
                    data-bs-dismiss="modal"
                    disabled={deleting}
                  >
                    {deleting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Deleting...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-trash me-2" />
                        Yes, Delete It
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
          <Modal
            show={openModal2}
            onHide={() => setOpenModal2(false)}
            centered
            backdrop="static"
          >
            <div className="modal-header border-0 justify-content-end p-3">
              <button
                className="btn-close"
                aria-label="Close"
                onClick={() => setOpenModal2(false)}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center pb-4">
              <div className="success-message">
                <div className="success-popup-icon bg-light-blue mx-auto mb-3 rounded-circle p-3">
                  <i className="ti ti-user-plus fs-36 text-primary" />
                </div>
                <h4 className="fw-semibold mb-1 text-success">
                  Contact Created Successfully!
                </h4>
                <p className="text-muted mb-4">
                  You can now view the full contact details.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light px-4"
                    onClick={() => setOpenModal2(false)}
                  >
                    Cancel
                  </button>
                  <Link
                    to={route.contactDetails}
                    className="btn btn-primary px-4"
                    onClick={() => setOpenModal2(false)}
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </Modal>
          <ConvertToLeadModal 
              show={showConvertToLeadModal} 
              onHide={() => setShowConvertToLeadModal(false)}
              selectedContacts={contacts
                .filter(c => selectedContacts.includes(c.contact_id))
                .map(c => ({
                  ...c,
                  // Map fields to match Contact interface in api/lead.ts
                  company_name: c.contact_Company_name || "", 
                  company_phone: c.contact_phone || "",
                  company_mail: c.contact_mail || "",
                  contact_person_name: c.contact_name || "",
                  contact_person_desigination: c.contact_desigination || "", 
                  company_remark: c.contact_description || "",
                  branch: c.branches || [],
                  users: { id: "", name: "", phone_no: "", email: "" } // Placeholder as it might not be needed for conversion logic
                })) as any} 
              onSuccess={() => {
                  dispatch(loadContacts());
                  dispatch(fetchReduxReLeadsThunk());
                  setSelectedContacts([]);
              }}
          />
        </div>
          {/* Contact Details Modal */}
        <ContactDetailsModal
          contact={selectedContactForView}
          isOpen={showViewDetailsModal}
          onClose={() => {
            setShowViewDetailsModal(false);
            setSelectedContactForView(null);
          }}
        />
        <SaveModal />
        <ModalDeleteEffect />
        <ScrollToTop />
      </>
    );
  };

  export default ContactList;